// @ts-nocheck
/**
 * Product Customizer — Accordion step logic, validation, and form integration.
 *
 * Each step is a <details> element. Completing a step collapses it and opens
 * the next one.  All values are written to hidden inputs with
 * name="properties[Label]" so Shopify includes them in the line item.
 *
 * Supports nested conditional branching (e.g. coin type → temple mode)
 * via .ls-conditional[data-*] wrappers. Only steps inside active conditionals
 * (or outside any conditional) are counted for progress / CTA.
 */

(function () {
  'use strict';

  /* ------------------------------------------------------------------
     Utilities
  ------------------------------------------------------------------ */

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.from((root || document).querySelectorAll(sel));
  }

  /** Convert kebab-case to camelCase for dataset access */
  function toCamel(s) {
    return s.replace(/-([a-z])/g, function (_, c) { return c.toUpperCase(); });
  }

  /**
   * Force iOS Safari to composite a fabric.js canvas to screen.
   * WebKit discards the backing store of canvases inside display:none
   * containers. After unhiding and calling renderAll(), the 2D context
   * is correct but the compositor ignores it. Toggling a GPU-layer
   * property and forcing a synchronous reflow makes it repaint.
   */
  function forceCanvasRepaint(fabricCanvas) {
    if (!fabricCanvas) return;
    var el = fabricCanvas.lowerCanvasEl;
    if (!el || !el.parentNode) return;
    el.parentNode.style.transform = 'translateZ(0)';
    void el.parentNode.offsetHeight;
    el.parentNode.style.transform = '';
  }

  /* ---------- DEBUG ---------- */
  var DEBUG = true;
  function dbg() {
    if (!DEBUG) return;
    var args = ['%c[LS-DEBUG]', 'color:#c8a45d;font-weight:bold'];
    for (var i = 0; i < arguments.length; i++) args.push(arguments[i]);
    console.log.apply(console, args);
  }

  /* ------------------------------------------------------------------
     LsProductCustomizer — one instance per section
  ------------------------------------------------------------------ */

  class LsProductCustomizer {
    /**
     * @param {HTMLElement} el  The .ls-customizer root element
     */
    constructor(el) {
      this.root = el;
      this.cta = qs('.ls-cta', el);
      this.progressEl = qs('.ls-progress', el);
      this.formId = el.dataset.formId || '';
      this.customizerType = el.dataset.customizerType || '';

      // Backup map for file inputs — iOS Safari clears input.files when a
      // parent <details> element toggles its open attribute.
      this._fileBackups = new Map();

      this._bindStepInputs();
      this._bindVariantSteps();
      this._bindFileUploads();
      this._bindConditionals();
      this._bindCruisePhotoLibrary();
      this._bindURLParams();
      this._bindFormSubmit();
      this._renumberSteps();
      this._markOptionalStepsComplete();
      this._updateProgress();
      this._updateCTA();

      // Auto-open first incomplete step
      this._openFirstIncomplete();

      // Relocate customizer into product-details column on desktop
      this._relocateCustomizer();
    }

    /* ---- Visible steps (excludes steps inside hidden conditionals) ---- */

    _getVisibleSteps() {
      var root = this._stepsRoot || this.root;
      return qsa('.ls-step', root).filter(function (step) {
        // Walk up from the step to the root, checking every .ls-conditional ancestor
        var el = step.parentElement;
        while (el && el !== root) {
          if (el.classList.contains('ls-conditional') && !el.classList.contains('is-active')) {
            return false;
          }
          el = el.parentElement;
        }
        // Also hide pre-filled steps
        if (step.classList.contains('ls-step--prefilled')) return false;
        return true;
      });
    }

    /* ---- Dynamic step renumbering ---- */

    _renumberSteps() {
      var visibleSteps = this._getVisibleSteps();
      visibleSteps.forEach(function (step, i) {
        var num = i + 1;
        var numberEl = qs('.ls-step__number', step);
        if (numberEl) numberEl.textContent = num;
        step.setAttribute('data-step', num);
      });
    }

    /* ---- Step input binding ---- */

    _bindStepInputs() {
      var allSteps = qsa('.ls-step', this.root);
      allSteps.forEach(function (step) {
        var inputs = qsa('input, select, textarea', step);
        inputs.forEach(function (input) {
          if (input.type === 'file') return; // handled separately
          input.addEventListener('change', this._onInputChange.bind(this, step, input));
          if (input.tagName === 'TEXTAREA' || input.type === 'text') {
            input.addEventListener('input', this._onTextInput.bind(this, step, input));
          }
        }.bind(this));
      }.bind(this));
    }

    _onInputChange(step, input) {
      // Scroll gallery to matching image when a button with data-gallery-alt is selected
      if (input.type === 'radio' && input.dataset.galleryAlt) {
        this._scrollGalleryToAlt(input.dataset.galleryAlt);
      }

      var propName = input.name;
      var value = input.value;

      // For radio/checkbox groups, find the checked value
      if (input.type === 'radio') {
        var checked = qs('input[name="' + propName + '"]:checked', step);
        value = checked ? checked.value : '';
      }

      // Update the step's selection display
      var selectionEl = qs('.ls-step__selection', step);
      if (selectionEl && value) {
        selectionEl.textContent = value;
      }

      // Check if step is complete
      this._checkStepCompletion(step);
    }

    _onTextInput(step, input) {
      // Update character count if present
      var counter = qs('.ls-text-field__char-count', input.closest('.ls-text-field'));
      if (counter) {
        var max = parseInt(input.getAttribute('maxlength'), 10) || 0;
        counter.textContent = input.value.length + (max ? ' / ' + max : '');
      }

      // Update selection display
      var selectionEl = qs('.ls-step__selection', step);
      if (selectionEl) {
        selectionEl.textContent = input.value;
      }

      // Re-check completion on every keystroke, but never auto-advance from here.
      //
      // A required text field counts as complete as soon as it holds one
      // character, so advancing on input closed the step after the first letter
      // typed and the customer had to click back in to finish the word. Radio and
      // swatch steps still advance, because picking one of those is a finished
      // answer; typing is not. The step is still marked complete, so the progress
      // bar, the step badge and the Add to Cart button all update as you type.
      this._checkStepCompletion(step, false);
    }

    /* ---- Gallery scroll on button selection ---- */

    _scrollGalleryToAlt(altText) {
      var gallery = document.querySelector('media-gallery');
      if (!gallery || !gallery.slideshow) return;

      // Slides are slideshow-slide elements; each wraps a product-media div
      var slides = gallery.querySelectorAll('slideshow-slide');
      for (var i = 0; i < slides.length; i++) {
        var img = slides[i].querySelector('img');
        if (img && img.alt === altText) {
          gallery.slideshow.select(i);
          return;
        }
      }
    }

    /* ---- Variant step binding ---- */

    _bindVariantSteps() {
      var variantDataEl = qs('[data-product-variants]', this.root);
      if (!variantDataEl) return;

      try {
        this._variants = JSON.parse(variantDataEl.textContent);
      } catch (e) {
        return;
      }

      // Parse option names (e.g. ["Size", "Orientation", "Printing Effect"])
      var optionNamesEl = qs('[data-variant-option-names]', this.root);
      if (optionNamesEl) {
        try {
          this._variantOptionNames = JSON.parse(optionNamesEl.textContent);
        } catch (e) {
          this._variantOptionNames = [];
        }
      }

      // Parse variant → media ID map (variant ID → Shopify media ID)
      var mediaMapEl = qs('[data-variant-media-map]', this.root);
      if (mediaMapEl) {
        try {
          this._variantMediaMap = JSON.parse(mediaMapEl.textContent);
        } catch (e) {
          this._variantMediaMap = {};
        }
      }

      var self = this;

      // Listen for changes on variant step radios (Size, Shape)
      var variantSteps = qsa('[data-variant-step]', this.root);
      variantSteps.forEach(function (step) {
        var inputs = qsa('input[data-option-position]', step);
        inputs.forEach(function (input) {
          input.addEventListener('change', function () {
            self._resolveVariant();
          });
        });
      });

      // Listen for Orientation changes on non-variant properties[] inputs
      // to trigger background swap even when Orientation isn't a variant option.
      var orientInputs = qsa('input[name="properties[Orientation]"]', this._stepsRoot || this.root);
      var isOrientVariant = this._variantOptionNames && this._variantOptionNames.indexOf('Orientation') !== -1;
      if (!isOrientVariant && orientInputs.length > 0) {
        orientInputs.forEach(function (input) {
          input.addEventListener('change', function () {
            // Build a minimal selectedOptions from current inputs
            var fakeOpts = {};
            if (self._variantOptionNames) {
              self._variantOptionNames.forEach(function (name, idx) {
                var pos = String(idx + 1);
                var el = qs('input[name="properties[' + name + ']"]:checked', self._stepsRoot || self.root)
                  || qs('input[data-option-position="' + pos + '"]:checked', self._stepsRoot || self.root);
                if (el) fakeOpts[pos] = el.value;
              });
            }
            self._handleVariantBgSwap(fakeOpts);
          });
        });
      }

      // Also listen for changes on hardcoded properties[] inputs that correspond
      // to variant options not handled by a variant step (e.g. Orientation,
      // Printing Effect, Style, Wood Base, etc.)
      if (this._variantOptionNames && this._variantOptionNames.length > 0) {
        var searchRoot = this._stepsRoot || this.root;

        // Which positions already have a variant step?
        var variantStepPositions = {};
        variantSteps.forEach(function (step) {
          var first = qs('input[data-option-position]', step);
          if (first) variantStepPositions[first.dataset.optionPosition] = true;
        });

        this._variantOptionNames.forEach(function (optName, idx) {
          var position = String(idx + 1);
          if (variantStepPositions[position]) return;

          var propInputs = qsa(
            'input[name="properties[' + optName + ']"], select[name="properties[' + optName + ']"]',
            searchRoot
          );
          propInputs.forEach(function (input) {
            input.addEventListener('change', function () {
              self._resolveVariant();
            });
          });
        });
      }
    }

    _resolveVariant() {
      if (!this._variants || !this._variantOptionNames) return;

      var searchRoot = this._stepsRoot || this.root;
      var selectedOptions = {};
      var totalPositions = this._variantOptionNames.length;

      // 1. Read from variant step radios (Size, Shape)
      qsa('[data-variant-step]', searchRoot).forEach(function (step) {
        var checked = qs('input[data-option-position]:checked', step);
        if (checked) {
          selectedOptions[checked.dataset.optionPosition] = checked.value;
        }
      });

      // 2. Read from hardcoded properties[] inputs for remaining variant options
      this._variantOptionNames.forEach(function (optName, idx) {
        var position = String(idx + 1);
        if (selectedOptions[position]) return;

        var checkedRadio = qs(
          'input[type="radio"][name="properties[' + optName + ']"]:checked',
          searchRoot
        );
        if (checkedRadio) {
          selectedOptions[position] = checkedRadio.value;
          return;
        }

        var select = qs('select[name="properties[' + optName + ']"]', searchRoot);
        if (select && select.value) {
          selectedOptions[position] = select.value;
          return;
        }

        var textInput = qs(
          'input[type="hidden"][name="properties[' + optName + ']"]',
          searchRoot
        );
        if (textInput && textInput.value) {
          selectedOptions[position] = textInput.value;
        }
      });

      var allSelected = Object.keys(selectedOptions).length >= totalPositions;

      // Find variants that match the currently selected options (partial or full)
      var candidates = [];
      for (var i = 0; i < this._variants.length; i++) {
        var v = this._variants[i];
        var isMatch = true;
        for (var pos in selectedOptions) {
          var optionKey = 'option' + pos;
          if (v[optionKey] !== selectedOptions[pos]) {
            isMatch = false;
            break;
          }
        }
        if (isMatch) candidates.push(v);
      }

      if (candidates.length === 0) return;

      // Update product gallery image when candidates share the same featured media
      this._updateGalleryImage(candidates);

      // Update price display — even with partial selection, if all matching
      // variants share the same price we can show it immediately
      var priceEl = qs('[data-variant-price]', searchRoot);
      if (priceEl) {
        var samePrice = true;
        for (var j = 1; j < candidates.length; j++) {
          if (candidates[j].price !== candidates[0].price) {
            samePrice = false;
            break;
          }
        }
        if (samePrice) {
          var formattedPrice = _formatMoney(candidates[0].price);
          priceEl.textContent = formattedPrice;

          // Also update the theme's product-price element
          var themePriceEl = document.querySelector('product-price .price');
          if (themePriceEl) themePriceEl.textContent = formattedPrice;
        }
      }

      // Trigger background swap even with partial selection — the swap
      // only needs Size (+ Orientation from properties[]), not all options.
      this._handleVariantBgSwap(selectedOptions);

      // Only update variant ID and availability when ALL options are selected
      if (!allSelected) return;

      var matched = candidates[0];

      // Update hidden variant ID input
      var form = qs('#' + this.formId);
      if (form) {
        var idInput = qs('input[name="id"]', form);
        if (idInput) idInput.value = matched.id;
      }

      // Update availability
      if (this.cta && !matched.available) {
        this.cta.textContent = 'Sold Out';
        this.cta.disabled = true;
      } else if (this.cta && matched.available) {
        this.cta.disabled = false;
      }
    }

    /**
     * Swap background image + reposition frame when variant options change.
     * Handles compound swaps (Size × Orientation → key), simple variant swaps
     * (Size → vinyl size, panel size), and orientation-only swaps.
     */
    _handleVariantBgSwap(selectedOptions) {
      var preview = this.root._lsPreview;
      if (!preview) return;

      var productBgEl = qs('.ls-preview__product-bg[data-swap-group]', preview.previewEl);
      if (!productBgEl) return;

      var group = productBgEl.dataset.swapGroup;
      var swapKey = null;

      // Read current option values by name
      var searchRoot = this._stepsRoot || this.root;
      var optionsByName = {};
      if (this._variantOptionNames) {
        this._variantOptionNames.forEach(function (name, idx) {
          var pos = String(idx + 1);
          if (selectedOptions[pos]) optionsByName[name] = selectedOptions[pos];
        });
      }

      // Also read properties[] inputs for non-variant options (e.g., Orientation, Style as hardcoded steps)
      var swapProps = ['Orientation', 'Style', 'Size', 'Display Type'];
      swapProps.forEach(function (prop) {
        if (optionsByName[prop]) return; // already have it from variant
        var radio = qs('input[name="properties[' + prop + ']"]:checked', searchRoot);
        if (radio) { optionsByName[prop] = radio.value; return; }
        var sel = qs('select[name="properties[' + prop + ']"]', searchRoot);
        if (sel && sel.value) { optionsByName[prop] = sel.value; return; }
        var hidden = qs('input[type="hidden"][name="properties[' + prop + ']"]', searchRoot);
        if (hidden && hidden.value) optionsByName[prop] = hidden.value;
      });

      if (group === 'print-size') {
        // Compound: Size × Orientation → "8x10Landscape"
        var sizeVal = optionsByName['Size'] || '';
        if (!sizeVal) {
          // Combined options. Shopify caps a product at 3 options, so the wood
          // prints merge two into one named "Size & Wood" — there is no option
          // literally called "Size", the lookup above misses, and the background
          // then never swapped at all on those products: not on size, and not on
          // orientation either, since the key is built from both.
          // Any option whose name contains "size" carries the dimensions.
          for (var optName in optionsByName) {
            if (!Object.prototype.hasOwnProperty.call(optionsByName, optName)) continue;
            if (optName.toLowerCase().indexOf('size') !== -1) {
              sizeVal = optionsByName[optName];
              break;
            }
          }
        }
        var orientVal = optionsByName['Orientation'] || 'Landscape';
        // Extract dimensions: 'Small 8" x 10"' → '8x10', 'Medium 11" x 14"' → '11x14'
        // \D* not \D+ so both '8" x 10"' and a bare '8x10' match — the combined
        // "Size & Wood" values are typed by hand in the admin and both turn up.
        var sizeMatch = sizeVal.match(/(\d+)\D*x\D*(\d+)/i);
        if (sizeMatch) {
          var orient = orientVal.charAt(0).toUpperCase() + orientVal.slice(1).toLowerCase();
          swapKey = sizeMatch[1] + 'x' + sizeMatch[2] + orient;
        }
      } else if (group === 'puzzle-variant') {
        // Compound: Size variant carries shape info ("5 x 7 Rectangle", "8 Round")
        var sizeVal = optionsByName['Size'] || '';
        var isRound = /round/i.test(sizeVal);
        if (isRound) {
          var roundMatch = sizeVal.match(/(\d+)/);
          if (roundMatch) swapKey = roundMatch[1] + 'Round';
        } else {
          var rectMatch = sizeVal.match(/(\d+)\D+x?\D+(\d+)/i);
          var orientVal = optionsByName['Orientation'] || 'Landscape';
          if (rectMatch) {
            var orient = orientVal.charAt(0).toUpperCase() + orientVal.slice(1).toLowerCase();
            swapKey = rectMatch[1] + 'x' + rectMatch[2] + orient;
          }
        }
      } else if (group === 'orientation') {
        // Simple: Orientation → "landscape" / "portrait"
        var orientVal = optionsByName['Orientation'] || '';
        if (orientVal) swapKey = orientVal.toLowerCase();
      } else if (group === 'vinyl-size') {
        // Size variant: "7 inch" → "7", "12 inch" → "12"
        var sizeVal = optionsByName['Size'] || '';
        var sizeNum = sizeVal.match(/(\d+)/);
        if (sizeNum) swapKey = sizeNum[1];
      } else if (group === 'panel-size') {
        // Size variant: "...18" tall" → "18", "...36" tall" → "36"
        var sizeVal = optionsByName['Size'] || '';
        if (/36/i.test(sizeVal)) swapKey = '36';
        else if (/18/i.test(sizeVal)) swapKey = '18';
      } else if (group === 'nightlight-style') {
        // Style variant: "1 - Dinosaur" → handleize → map to room
        var styleVal = optionsByName['Style'] || '';
        // Handleize: lowercase, spaces→dashes, collapse consecutive dashes
        var handleized = styleVal.toLowerCase().replace(/[^a-z0-9-]+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
        var nightlightMap = {
          '1-dinosaur': 'room1', '2-highland-cow': 'room1', '3-kitten': 'room1',
          '4-tiger': 'room1', '5-puppy': 'room1', '6-fire-engine': 'room1',
          '7-tractor': 'room1', '8-dump-truck': 'room2', '9-police-car': 'room2',
          '10-train': 'room2', '11-bubbles': 'room2', '12-moon-scape': 'room2',
          '13-planets': 'room2', '14-stained-glass': 'room2',
          '15-sunshine': 'room3', '16-hot-air-balloon': 'room3',
          '17-girl-balloons': 'room3', '18-boy-balloons': 'room3',
          '19-butterfly': 'room3', '20-teddy-bear': 'room3'
        };
        if (nightlightMap[handleized]) {
          swapKey = nightlightMap[handleized];
        }
      }

      if (!swapKey) return;

      var swapSrc = productBgEl.getAttribute('data-swap-' + swapKey);
      if (!swapSrc) return;

      // Swap the background image
      var imgEl = qs('.ls-preview__product-bg-img', productBgEl);
      if (imgEl && imgEl.src !== swapSrc) {
        imgEl.src = swapSrc;

        // Save photo data URLs before clearing
        var savedDataUrl = preview._photoDataUrl;
        var savedMirrorUrls = preview._mirrorDataUrls ? preview._mirrorDataUrls.slice() : [];

        // Remove old mirror canvases
        preview._clearMirrors();
        preview._mirrors.forEach(function(m) {
          if (m.fabricCanvas) m.fabricCanvas.dispose();
          m.wrapper.remove();
        });
        preview._mirrors = [];
        preview._mirrorPhotos = [];

        // Update photoAreas from swapAreas
        var swap = preview.config.swapAreas;
        if (swap && swap[group] && swap[group][swapKey]) {
          preview.config.photoAreas = swap[group][swapKey];
          preview._positionFrame();
        }

        // Re-add photos
        if (preview.config.multiPhoto) {
          if (savedDataUrl) preview._addPhotoToCanvas(savedDataUrl);
          for (var mi = 0; mi < savedMirrorUrls.length; mi++) {
            if (savedMirrorUrls[mi] && preview._mirrors[mi]) {
              (function (idx, m, url) {
                m.wrapper.style.display = '';
                requestAnimationFrame(function () {
                  var retries = 0;
                  (function tryRestore() {
                    if (!m.fabricCanvas) preview._initSingleMirror(m);
                    if (!m.fabricCanvas && retries++ < 60) {
                      setTimeout(tryRestore, retries < 10 ? 50 : 150);
                      return;
                    }
                    if (m.fabricCanvas) preview._addPhotoToMirror(idx, m, url);
                  })();
                });
              })(mi, preview._mirrors[mi], savedMirrorUrls[mi]);
            }
          }
          preview._mirrorDataUrls = savedMirrorUrls;
        } else {
          if (savedDataUrl) {
            preview._addPhotoToCanvas(savedDataUrl);
            preview._updateMirrors(savedDataUrl);
          }
        }
      }
    }

    /* ---- Gallery image swap on variant selection ---- */

    _updateGalleryImage(candidates) {
      if (!this._variantMediaMap) return;

      // Find a candidate that has a featured media
      var variantId = null;
      var mediaId = null;
      for (var i = 0; i < candidates.length; i++) {
        var mapped = this._variantMediaMap[String(candidates[i].id)];
        if (mapped) {
          variantId = candidates[i].id;
          mediaId = mapped;
          break;
        }
      }

      if (!mediaId || mediaId === this._lastGalleryMediaId) return;
      this._lastGalleryMediaId = mediaId;

      // Fetch the product page with the selected variant to get the updated gallery
      var productUrl = this.root.dataset.productUrl;
      if (!productUrl) return;

      var fetchUrl = productUrl + (productUrl.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variantId;

      // Abort any in-flight gallery fetch
      if (this._galleryAbort) this._galleryAbort.abort();
      this._galleryAbort = new AbortController();

      var self = this;

      fetch(fetchUrl, { signal: this._galleryAbort.signal })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGallery = doc.querySelector('media-gallery');
          var currentGallery = document.querySelector('media-gallery');
          if (newGallery && currentGallery) {
            // The gallery is swapped for a brand new node, so two things that
            // point at the old one have to be carried across.
            //
            // 1. Its hidden state. LsPreview hides the gallery while the preview
            //    is on screen; the replacement arrives visible, which is why the
            //    product photo reappeared underneath the preview on the acrylic
            //    block — the one product where variant media swapping actually
            //    runs, so the one place this replacement ever happens.
            // 2. LsPreview._gallery itself, captured at relocation time. Left
            //    stale it points at a detached node, so _showPreview() hides
            //    nothing, _hidePreview() restores nothing, and the "Back to
            //    Preview" button is inserted against a node that is gone.
            var wasHidden = currentGallery.style.display === 'none';
            currentGallery.replaceWith(newGallery);

            var preview = self.root._lsPreview;
            if (preview && preview._gallery === currentGallery) {
              preview._gallery = newGallery;
            }
            if (wasHidden) newGallery.style.display = 'none';
          }
        })
        .catch(function (e) {
          if (e.name !== 'AbortError') console.error(e);
        });
    }

    /* ---- Step completion ---- */

    _markOptionalStepsComplete() {
      var allSteps = qsa('.ls-step', this.root);
      allSteps.forEach(function (step) {
        var required = qsa('[required], [data-required]', step);
        if (required.length === 0) {
          step.setAttribute('data-optional', '');
        }
      });
    }

    /**
     * @param {Element} step
     * @param {boolean} [allowAdvance=true] - pass false to mark the step complete
     *   without auto-advancing to the next one. Used while the customer is typing.
     */
    _checkStepCompletion(step, allowAdvance) {
      if (allowAdvance === undefined) allowAdvance = true;
      var required = qsa('[required], [data-required]', step);
      var complete = true;
      var fileBackups = this._fileBackups;

      required.forEach(function (input) {
        if (input.type === 'radio') {
          var groupName = input.name;
          var checked = qs('input[name="' + groupName + '"]:checked', step);
          if (!checked) complete = false;
        } else if (input.type === 'file') {
          var hasFile = (input.files && input.files.length > 0) || fileBackups.has(input);
          if (!hasFile) complete = false;
        } else if (input.tagName === 'SELECT') {
          if (!input.value) complete = false;
        } else {
          if (!input.value.trim()) complete = false;
        }
      });

      if (complete) {
        this._markComplete(step, allowAdvance);
      } else {
        step.removeAttribute('data-completed');
      }

      this._updateProgress();
      this._updateCTA();
    }

    _markComplete(step, allowAdvance) {
      if (allowAdvance === undefined) allowAdvance = true;
      var wasAlreadyComplete = step.hasAttribute('data-completed');
      step.setAttribute('data-completed', '');

      // Caller asked for completion only — typing, not a finished answer.
      if (!allowAdvance) return;

      // Skip auto-advance if step was already marked complete
      if (wasAlreadyComplete) return;

      // Auto-advance: close current, open next visible step after a short delay.
      // Optional steps are pre-marked data-completed but should still open in
      // the natural flow so the customer can fill them or consciously skip them.
      var self = this;
      setTimeout(function () {
        step.removeAttribute('open');
        var visibleSteps = self._getVisibleSteps();
        var idx = visibleSteps.indexOf(step);
        if (idx !== -1 && idx + 1 < visibleSteps.length) {
          visibleSteps[idx + 1].setAttribute('open', '');
        }
      }, 300);
    }

    /* ---- Progress ---- */

    _updateProgress() {
      var visibleSteps = this._getVisibleSteps();
      var requiredSteps = visibleSteps.filter(function (s) {
        return !s.hasAttribute('data-optional');
      });
      var total = requiredSteps.length;
      var completed = requiredSteps.filter(function (s) {
        return s.hasAttribute('data-completed');
      }).length;
      var searchRoot = this._stepsRoot || this.root;
      var textEl = qs('.ls-progress__text', searchRoot);
      var fillEl = qs('.ls-progress__fill', searchRoot);
      if (textEl) textEl.textContent = 'Step ' + Math.min(completed + 1, total) + ' of ' + total;
      if (fillEl) fillEl.style.width = (total > 0 ? (completed / total) * 100 : 0) + '%';
    }

    /* ---- CTA ---- */

    _updateCTA() {
      if (!this.cta) return;
      var visibleSteps = this._getVisibleSteps();
      var requiredSteps = visibleSteps.filter(function (s) {
        return !s.hasAttribute('data-optional');
      });
      var total = requiredSteps.length;
      var completed = requiredSteps.filter(function (s) {
        return s.hasAttribute('data-completed');
      }).length;
      var allDone = completed === total && total > 0;

      this.cta.disabled = !allDone;

      if (allDone) {
        this.cta.textContent = 'Add to Cart';
      } else {
        var remaining = total - completed;
        this.cta.textContent = 'Complete ' + (remaining === 1 ? 'Last Step' : 'All ' + remaining + ' Steps') + ' to Add to Cart';
      }
    }

    /* ---- File uploads ---- */

    _bindFileUploads() {
      var uploads = qsa('.ls-file-upload', this.root);
      uploads.forEach(function (uploadEl) {
        var dropzone = qs('.ls-file-upload__dropzone', uploadEl);
        var input = qs('input[type="file"]', uploadEl);
        var preview = qs('.ls-file-upload__preview', uploadEl);
        var thumb = qs('.ls-file-upload__thumb', uploadEl);
        var nameEl = qs('.ls-file-upload__name', uploadEl);
        var sizeEl = qs('.ls-file-upload__size', uploadEl);
        var removeBtn = qs('.ls-file-upload__remove', uploadEl);

        if (!dropzone || !input) return;

        // Click to upload
        dropzone.addEventListener('click', function () {
          input.click();
        });

        // Drag & drop
        dropzone.addEventListener('dragover', function (e) {
          e.preventDefault();
          dropzone.classList.add('is-dragover');
        });
        dropzone.addEventListener('dragleave', function () {
          dropzone.classList.remove('is-dragover');
        });
        dropzone.addEventListener('drop', function (e) {
          e.preventDefault();
          dropzone.classList.remove('is-dragover');
          if (e.dataTransfer.files.length) {
            input.files = e.dataTransfer.files;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        // File selected
        input.addEventListener('change', function () {
          var file = input.files[0];
          if (!file) return;

          // Back up the file — iOS Safari clears input.files when a parent
          // <details> element toggles its open attribute.
          this._fileBackups.set(input, file);

          // Show preview
          if (preview) {
            preview.classList.add('is-visible');
            dropzone.style.display = 'none';
          }
          if (nameEl) nameEl.textContent = file.name;
          if (sizeEl) sizeEl.textContent = _formatFileSize(file.size);

          // Thumbnail
          if (thumb && file.type.startsWith('image/')) {
            var reader = new FileReader();
            reader.onload = function (e) {
              thumb.src = e.target.result;
            };
            reader.readAsDataURL(file);
          }

          // Update selection text in header
          var step = uploadEl.closest('.ls-step');
          var selectionEl = qs('.ls-step__selection', step);
          if (selectionEl) selectionEl.textContent = file.name;

          // Check step completion — don't auto-advance if the step also
          // contains text fields the customer still needs to fill in.
          var hasTextFields = step && qs('.ls-text-field', step);
          if (step) this._checkStepCompletion(step, !hasTextFields);
        }.bind(this));

        // Remove file
        if (removeBtn) {
          removeBtn.addEventListener('click', function () {
            input.value = '';
            this._fileBackups.delete(input);
            if (preview) {
              preview.classList.remove('is-visible');
              dropzone.style.display = '';
            }
            if (thumb) thumb.src = '';

            var step = uploadEl.closest('.ls-step');
            var selectionEl = qs('.ls-step__selection', step);
            if (selectionEl) selectionEl.textContent = '';

            if (step) {
              step.removeAttribute('data-completed');
              this._updateProgress();
              this._updateCTA();
            }
          }.bind(this));
        }
      }.bind(this));
    }

    /* ---- Cruise Photo Library modal integration ---- */

    _bindCruisePhotoLibrary() {
      var self = this;
      var searchRoot = this._stepsRoot || this.root;

      // Browse button(s) — one in the step, one on the preview's "Change" button
      var btns = qsa('[data-open-photo-library]', searchRoot);
      if (!btns.length) return;

      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var modal = document.getElementById('ls-cruise-photo-library');
          if (modal && typeof modal.showDialog === 'function') {
            modal.showDialog();
          }
        });
      });

      // Listen for photo selection from the modal.
      // Look up searchRoot dynamically — _relocateCustomizer may move elements
      // after this closure is created.
      document.addEventListener('cruise-photo-selected', function (e) {
        var detail = e.detail;
        if (!detail || !detail.id) return;

        var currentRoot = self._stepsRoot || self.root;
        var input = qs('[data-cruise-photo-input]', currentRoot);
        if (!input) return;

        // Set the hidden input values (ID + image URL)
        input.value = detail.id;
        var imageInput = qs('[data-cruise-photo-image-input]', currentRoot);
        if (imageInput) imageInput.value = detail.src || '';

        // Update selection display in the step header
        var step = input.closest('.ls-step');
        if (step) {
          var selectionEl = qs('.ls-step__selection', step);
          if (selectionEl) selectionEl.textContent = 'Photo ' + detail.id;
        }

        // Show preview
        var preview = qs('[data-cruise-photo-preview]', currentRoot);
        if (preview) {
          var img = qs('.ls-cruise-photo-preview__img', preview);
          var idEl = qs('.ls-cruise-photo-preview__id', preview);
          var catEl = qs('.ls-cruise-photo-preview__category', preview);
          if (img) img.src = detail.src || '';
          if (idEl) idEl.textContent = 'Photo ' + detail.id;
          if (catEl) catEl.textContent = detail.category || '';
          preview.style.display = '';
        }

        // Close the modal
        var modal = document.getElementById('ls-cruise-photo-library');
        if (modal && typeof modal.closeDialog === 'function') {
          modal.closeDialog();
        }

        // Trigger step completion
        if (step) {
          self._checkStepCompletion(step);
        }
      });
    }

    /* ---- URL params pre-fill ---- */

    _bindURLParams() {
      var params = new URLSearchParams(window.location.search);

      params.forEach(function (value, key) {
        // Find inputs whose property name matches
        var inputs = qsa('input[value="' + CSS.escape(value) + '"]', this.root);
        inputs.forEach(function (input) {
          var propKey = (input.name || '').replace('properties[', '').replace(']', '');
          if (propKey.toLowerCase().replace(/\s+/g, '_') === key.toLowerCase().replace(/\s+/g, '_')) {
            input.checked = true;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        // Also handle select elements
        var selects = qsa('select', this.root);
        selects.forEach(function (select) {
          var propKey = (select.name || '').replace('properties[', '').replace(']', '');
          if (propKey.toLowerCase().replace(/\s+/g, '_') === key.toLowerCase().replace(/\s+/g, '_')) {
            select.value = value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }.bind(this));

      // Both coin paths below apply only to the combined 'coin' type, which still
      // has the coin type step. On a per-coin product the coin is fixed by the
      // product itself and its block is already active from the server, so the
      // 'missionary' default further down must not run — it would activate the
      // wrong block and clear the preview.
      if (this.root.dataset.coinType) return;

      // Coin type URL pre-fill — hide Step 1 if pre-filled
      var coinType = params.get('coin_type');
      if (coinType && this.customizerType === 'coin') {
        // Find the coin type step (Step 1) and hide it
        var step1 = qs('.ls-step[data-step="1"]', this.root);
        if (step1) {
          step1.classList.add('ls-step--prefilled');
          step1.setAttribute('data-completed', '');
          step1.removeAttribute('open');
        }
        // Activate the coin type conditional
        this._activateConditional('coin-type', coinType);
      }

      // Default to Missionary if no coin_type URL param
      if (!coinType && this.customizerType === 'coin') {
        var defaultType = 'missionary';
        var defaultRadio = qs('input[data-coin-type="' + defaultType + '"]', this.root);
        if (defaultRadio) {
          defaultRadio.checked = true;
          var step = defaultRadio.closest('.ls-step');
          if (step) {
            var selectionEl = qs('.ls-step__selection', step);
            if (selectionEl) selectionEl.textContent = defaultRadio.value;
          }
        }
        this._activateConditional('coin-type', defaultType);
      }
    }

    /* ---- Generic conditional branching ---- */

    _bindConditionals() {
      // Conditional groups are derived from the DOM rather than a hardcoded list.
      //
      // A "group" is any data-* attribute that appears on BOTH a .ls-conditional
      // wrapper and an input -- that pairing is what links a trigger button to the
      // blocks it reveals.
      //
      // This used to be a hand-maintained array and it had drifted out of sync with
      // the section Liquid: 'plaque-style', 'temple-display' and 'sports-mount' were
      // never in the list, so those blocks could never receive .is-active and every
      // step after the trigger stayed hidden (.ls-conditional is display:none until
      // activated). The array also still held three keys the Liquid no longer emits
      // ('shadow-box-occasion', 'desktop-plaque-occasion', 'print-media-material').
      // Deriving the list means adding a new branch in Liquid needs no JS change.
      var self = this;
      var groups = {};

      qsa('.ls-conditional', this.root).forEach(function (block) {
        Array.prototype.forEach.call(block.attributes, function (attr) {
          if (attr.name.indexOf('data-') !== 0) return;
          var group = attr.name.slice(5);
          if (groups[group]) return;
          // Only treat it as a group if an input carries the same attribute.
          // Descriptive attributes on the wrapper (data-style-label,
          // data-photo-count) have no matching input and are ignored.
          if (qs('input[data-' + group + ']', self.root)) groups[group] = true;
        });
      });

      // Also register groups from data-swap-group on product-bg elements
      // (these swap the bg image without needing a .ls-conditional div)
      // At init time the preview hasn't been relocated yet, so search this.root
      qsa('[data-swap-group]', this.root).forEach(function (el) {
        var group = el.dataset.swapGroup;
        if (!groups[group] && qs('input[data-' + group + ']', self.root)) {
          groups[group] = true;
        }
      });

      Object.keys(groups).forEach(function (group) {
        var camel = toCamel(group);
        qsa('input[data-' + group + ']', self.root).forEach(function (input) {
          input.addEventListener('change', function () {
            if (input.checked) {
              self._activateConditional(group, input.dataset[camel]);
            }
          });
        });
      });
    }

    _activateConditional(group, value) {
      var attr = 'data-' + group;
      var searchRoot = this._stepsRoot || this.root;
      var conditionals = qsa('.ls-conditional[' + attr + ']', searchRoot);
      conditionals.forEach(function (el) {
        if (el.getAttribute(attr) === value) {
          el.classList.add('is-active');
        } else {
          el.classList.remove('is-active');
          // Reset completed state and close steps inside deactivated conditionals
          qsa('.ls-step', el).forEach(function (step) {
            step.removeAttribute('data-completed');
            step.removeAttribute('open');
          });
          // Reset file inputs inside deactivated conditionals
          qsa('input[type="file"]', el).forEach(function (input) {
            input.value = '';
            var uploadEl = input.closest('.ls-file-upload');
            if (uploadEl) {
              var preview = qs('.ls-file-upload__preview', uploadEl);
              var dropzone = qs('.ls-file-upload__dropzone', uploadEl);
              var thumb = qs('.ls-file-upload__thumb', uploadEl);
              if (preview) preview.classList.remove('is-visible');
              if (dropzone) dropzone.style.display = '';
              if (thumb) thumb.src = '';
            }
          });
          // Also deactivate any nested sub-conditionals
          qsa('.ls-conditional', el).forEach(function (nested) {
            nested.classList.remove('is-active');
          });
        }
      });

      // Clear canvases and swap background image when switching coin type
      if (group === 'coin-type') {
        var preview = this.root._lsPreview;
        if (preview) {
          preview._removePhoto('front');
          preview._removePhoto('back');

          // Swap coin background image to match selected type
          // Use preview.previewEl because .ls-preview may be relocated outside this.root
          var coinBgEl = qs('.ls-preview__coin-bg', preview.previewEl);
          if (coinBgEl) {
            var camelVal = value.charAt(0).toUpperCase() + value.slice(1).replace(/-([a-z])/g, function(_, c) { return c.toUpperCase(); });
            var newSrc = coinBgEl.dataset['coinBg' + camelVal];
            if (newSrc) {
              qs('.ls-preview__coin-bg-img', coinBgEl).src = newSrc;
            }

            // Reposition coin frames to match the new image's circle positions
            preview._repositionCoinFrames(value);
          }
        }
      }

      // Swap product-bg image and reposition frame when a conditional matches data-swap-group
      // Search in both this.root and the (possibly relocated) preview element
      var preview = this.root._lsPreview;
      var productBgEl = qs('.ls-preview__product-bg[data-swap-group="' + group + '"]', this.root)
        || (preview && preview.previewEl ? qs('.ls-preview__product-bg[data-swap-group="' + group + '"]', preview.previewEl) : null);
      if (productBgEl) {
        // Map many-to-one: multiple option values can share a single swap image
        var SWAP_VALUE_MAP = {
          'acrylic-shape': {
            '2-square': '2Square', '3-square': '3Square', '4-square': '4Square', '6-square': '6Square',
            // '4-round' used to point at '3Round', so the 3" and 4" round blocks
            // both showed the 3" mockup. It has its own image now.
            '2-round': '2Round', '3-round': '3Round', '4-round': '4Round',
            // The heart comes in a plain version and one on a stand. Both
            // spellings of the stand variant handleize the same way — '5-1/2"
            // Heart w Stand' and '5-1/2" Heart w/ Stand' both give
            // '5-1-2-heart-w-stand' — but 'with' instead of 'w' would not, hence
            // the substring fallback below this map.
            '5-1-2-heart': 'heart',
            '5-1-2-heart-w-stand': 'heartStand',
            'puzzle-piece-single': 'puzzleSingle', 'puzzle-pieces-double': 'puzzleDouble'
          },
          'plaque-style': {
            'style-1': 'style1', 'style-2': 'style2', 'style-3': 'style3', 'style-4': 'style4',
            'style-5': 'style5', 'style-6': 'style6', 'style-7': 'style7', 'style-8': 'style8',
            'style-9': 'style9', 'style-10': 'style10'
          },
          'nightlight-style': {
            '1-dinosaur': 'room1', '2-highland-cow': 'room1', '3-kitten': 'room1',
            '4-tiger': 'room1', '5-puppy': 'room1', '6-fire-engine': 'room1',
            '7-tractor': 'room1', '8-dump-truck': 'room2', '9-police-car': 'room2',
            '10-train': 'room2', '11-bubbles': 'room2', '12-moon-scape': 'room2',
            '13-planets': 'room2', '14-stained-glass': 'room2',
            '15-sunshine': 'room3', '16-hot-air-balloon': 'room3',
            '17-girl-balloons': 'room3', '18-boy-balloons': 'room3',
            '19-butterfly': 'room3', '20-teddy-bear': 'room3'
          }
        };
        var mappedValue = (SWAP_VALUE_MAP[group] && SWAP_VALUE_MAP[group][value]) || value;

        // Acrylic heart fallback. The map is exact-match, and a variant renamed
        // in the admin ("w" to "with", "5.5" instead of "5-1/2") handleizes to a
        // key that is not in the map — which fails silently: no swap, the mockup
        // just stays on whatever was showing. The two heart shapes are the only
        // ones distinguished by a word rather than a number, so they are the ones
        // exposed to that. Anything containing 'heart' resolves here.
        if (group === 'acrylic-shape' && !SWAP_VALUE_MAP[group][value] && value.indexOf('heart') !== -1) {
          mappedValue = value.indexOf('stand') !== -1 ? 'heartStand' : 'heart';
        }

        var swapSrc = productBgEl.getAttribute('data-swap-' + mappedValue);
        if (swapSrc) {
          var imgEl = qs('.ls-preview__product-bg-img', productBgEl);
          if (imgEl) imgEl.src = swapSrc;

          if (preview) {
            // Save existing photo data URLs before clearing
            var savedDataUrl = preview._photoDataUrl;
            var savedMirrorUrls = preview._mirrorDataUrls ? preview._mirrorDataUrls.slice() : [];

            // Remove old mirror canvases from DOM
            preview._clearMirrors();
            preview._mirrors.forEach(function(m) {
              if (m.fabricCanvas) m.fabricCanvas.dispose();
              m.wrapper.remove();
            });
            preview._mirrors = [];
            preview._mirrorPhotos = [];

            // Update photoAreas from swapAreas config and reposition
            var swap = preview.config.swapAreas;
            if (swap && swap[group] && swap[group][mappedValue]) {
              preview.config.photoAreas = swap[group][mappedValue];
              preview._positionFrame();
            }

            // Re-add photos
            if (preview.config.multiPhoto) {
              // Multi-photo: restore each photo independently
              if (savedDataUrl) {
                preview._addPhotoToCanvas(savedDataUrl);
              }
              for (var mi = 0; mi < savedMirrorUrls.length; mi++) {
                if (savedMirrorUrls[mi] && preview._mirrors[mi]) {
                  (function (idx, m, url) {
                    m.wrapper.style.display = '';
                    requestAnimationFrame(function () {
                      var retries = 0;
                      (function tryRestore() {
                        if (!m.fabricCanvas) preview._initSingleMirror(m);
                        if (!m.fabricCanvas && retries++ < 60) {
                          setTimeout(tryRestore, retries < 10 ? 50 : 150);
                          return;
                        }
                        if (m.fabricCanvas) preview._addPhotoToMirror(idx, m, url);
                      })();
                    });
                  })(mi, preview._mirrors[mi], savedMirrorUrls[mi]);
                }
              }
              preview._mirrorDataUrls = savedMirrorUrls;
            } else {
              // Single-photo: mirror the same image to all areas
              if (savedDataUrl) {
                preview._addPhotoToCanvas(savedDataUrl);
                preview._updateMirrors(savedDataUrl);
              }
            }
          }
        }
      }

      // Renumber, recalculate progress and CTA
      this._renumberSteps();
      this._markOptionalStepsComplete();
      this._updateProgress();
      this._updateCTA();

      // Open first incomplete visible step after conditional change
      var visibleSteps = this._getVisibleSteps();
      for (var i = 0; i < visibleSteps.length; i++) {
        if (!visibleSteps[i].hasAttribute('data-completed')) {
          visibleSteps[i].setAttribute('open', '');
          break;
        }
      }
    }

    /* ---- Form submission (fetch, matches theme pattern) ---- */

    _bindFormSubmit() {
      var form = qs('#' + this.formId);
      if (!form) return;
      var self = this;

      function submitFormData(formData) {
        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (data.status) {
            alert(data.description || data.message || 'Could not add to cart.');
            self._updateCTA();
            return;
          }

          self.cta.textContent = 'Added to Cart!';

          /* Fetch fresh cart to get item_count, then trigger theme cart drawer */
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: {
                resource: cart,
                sourceId: self.formId,
                data: {
                  itemCount: cart.item_count,
                  sections: {}
                }
              }
            }));

          });

          setTimeout(function () {
            self._updateCTA();
          }, 1200);
        })
        .catch(function () {
          alert('Something went wrong. Please try again.');
          self._updateCTA();
        });
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (self.cta && self.cta.disabled) return;

        var formData = new FormData(form);

        // Restore any file inputs that iOS Safari may have cleared when
        // their parent <details> element was toggled.
        self._fileBackups.forEach(function (file, input) {
          if (!input.files || !input.files.length) {
            var name = input.getAttribute('name');
            if (name) {
              formData.delete(name);
              formData.append(name, file, file.name);
            }
          }
        });

        self.cta.disabled = true;
        self.cta.textContent = 'Adding...';

        // Export canvas preview(s) as JPEG files before submitting
        var preview = self.root._lsPreview;
        if (preview && preview.canvas && preview.photoImage) {

          // For productBg types, composite the full product mockup (bg + photo canvases)
          if (preview.config && preview.config.productBg) {
            var bgImgEl = qs('.ls-preview__product-bg-img', preview.previewEl);
            var frameEl = qs('.ls-preview__frame', qs('.ls-preview__product-bg', preview.previewEl));
            if (bgImgEl && bgImgEl.src && frameEl) {
              // Load bg image with crossOrigin to avoid tainting
              var bgImg = new Image();
              bgImg.crossOrigin = 'anonymous';
              bgImg.onload = function () {
                var W = bgImg.naturalWidth;
                var H = bgImg.naturalHeight;
                var offscreen = document.createElement('canvas');
                offscreen.width = W;
                offscreen.height = H;
                var ctx = offscreen.getContext('2d');

                // Draw product background
                ctx.drawImage(bgImg, 0, 0, W, H);

                // Helper: draw a fabric canvas at its frame position (CSS % → px)
                function drawCanvasAt(fabricCanvas, el) {
                  var left   = parseFloat(el.style.left)   / 100 * W;
                  var top    = parseFloat(el.style.top)    / 100 * H;
                  var width  = parseFloat(el.style.width)  / 100 * W;
                  var height = parseFloat(el.style.height) / 100 * H;
                  var srcCanvas = fabricCanvas.toCanvasElement();
                  ctx.drawImage(srcCanvas, left, top, width, height);
                }

                // Draw main canvas
                drawCanvasAt(preview.canvas, frameEl);

                // Draw mirror canvases
                if (preview._mirrors && preview._mirrors.length) {
                  preview._mirrors.forEach(function (m) {
                    if (m.fabricCanvas && m.wrapper && m.wrapper.style.display !== 'none') {
                      drawCanvasAt(m.fabricCanvas, m.wrapper);
                    }
                  });
                }

                offscreen.toBlob(function (blob) {
                  if (blob) {
                    formData.append('properties[_Preview]', new File([blob], 'preview.jpg', { type: 'image/jpeg' }));
                  }
                  submitFormData(formData);
                }, 'image/jpeg', 0.85);
              };
              bgImg.onerror = function () {
                // Fallback: export bare canvas if bg image fails to load cross-origin
                preview.canvas.toCanvasElement().toBlob(function (blob) {
                  if (blob) {
                    formData.append('properties[_Preview]', new File([blob], 'preview.jpg', { type: 'image/jpeg' }));
                  }
                  submitFormData(formData);
                }, 'image/jpeg', 0.85);
              };
              bgImg.src = bgImgEl.src;
              return; // async — the onload/onerror will call submitFormData
            }
          }

          // Non-productBg types (coins, standalone): export bare canvas
          preview.canvas.toCanvasElement().toBlob(function (blob) {
            if (blob) {
              formData.append('properties[_Preview]', new File([blob], 'preview.jpg', { type: 'image/jpeg' }));
            }

            // For coins: also export back canvas
            if (preview.backCanvas && preview.backPhotoImage) {
              preview.backCanvas.toCanvasElement().toBlob(function (backBlob) {
                if (backBlob) {
                  formData.append('properties[_Preview Back]', new File([backBlob], 'preview-back.jpg', { type: 'image/jpeg' }));
                }
                submitFormData(formData);
              }, 'image/jpeg', 0.85);
            } else {
              submitFormData(formData);
            }
          }, 'image/jpeg', 0.85);
        } else {
          submitFormData(formData);
        }
      });
    }

    /* ---- Relocate customizer into product-details column ---- */

    _relocateCustomizer() {

      var detailsCol = document.querySelector('.product-details .group-block-content');
      if (!detailsCol) return;

      // Find the accordion element to insert before
      var accordion = detailsCol.querySelector('.accordion');

      // Collect our customizer content: top-level steps, conditionals, variant data, progress, CTA, trust badges
      // Only grab direct children to preserve nesting (steps inside conditionals stay nested)
      var children = Array.from(this.root.children).filter(function (el) {
        return el.classList.contains('ls-step') || el.classList.contains('ls-conditional')
          || (el.tagName === 'SCRIPT' && el.hasAttribute('data-product-variants'));
      });
      var progress = qs('.ls-progress', this.root);
      var variantPrice = qs('[data-variant-price]', this.root);
      var cta = this.cta;
      // Anything not moved below is left in the original section, which this
      // function then hides — so a new element under the CTA has to be listed here
      // or it vanishes on desktop while still rendering fine on mobile.
      var proofNote = qs('.ls-proof-note', this.root);
      var trustBadges = qs('.ls-trust-badges', this.root);

      // Create a wrapper to hold relocated content
      var wrapper = document.createElement('div');
      wrapper.className = 'ls-customizer-relocated';

      // Move steps and conditionals (preserving nesting)
      children.forEach(function (el) {
        wrapper.appendChild(el);
      });

      // Move progress, price, CTA, proof note, trust badges
      if (progress) wrapper.appendChild(progress);
      if (variantPrice) wrapper.appendChild(variantPrice);
      if (cta) wrapper.appendChild(cta);
      if (proofNote) wrapper.appendChild(proofNote);
      if (trustBadges) wrapper.appendChild(trustBadges);

      // Insert before accordion, or append at end
      if (accordion) {
        accordion.parentNode.insertBefore(wrapper, accordion);
      } else {
        detailsCol.appendChild(wrapper);
      }

      // Track the new root for step queries
      this._stepsRoot = wrapper;

      // Mark the original section as relocated
      this.root.classList.add('ls-customizer--relocated');

      // Hide the original section container if it's now empty (just form + preview)
      var section = this.root.closest('.ls-product-customizer-section');
      if (section) section.style.display = 'none';
    }

    /* ---- Open first incomplete step ---- */

    _openFirstIncomplete() {
      var visibleSteps = this._getVisibleSteps();
      for (var i = 0; i < visibleSteps.length; i++) {
        if (!visibleSteps[i].hasAttribute('data-completed')) {
          visibleSteps[i].setAttribute('open', '');
          return;
        }
      }
    }
  }

  /* ---- Helpers ---- */

  function _formatFileSize(bytes) {
    if (bytes < 1024) return bytes + ' B';
    if (bytes < 1048576) return (bytes / 1024).toFixed(1) + ' KB';
    return (bytes / 1048576).toFixed(1) + ' MB';
  }

  /** Format Shopify price (cents) as currency string */
  function _formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  /* ------------------------------------------------------------------
     LsPreview — Live product preview driven by customizer inputs
  ------------------------------------------------------------------ */

  /** Maps option labels to CSS custom property values */
  var OPTION_MAPS = {
    frameColor: {
      'Black':        '#1a1a1a',
      'White':        '#f5f5f5',
      'Walnut':       '#5C4033',
      'Natural Oak':  '#C4A882',
      'Natural Wood': '#C4A882',
      'Cherry':       '#7B3F00',
      'Classic Black':'#1a1a1a',
      'None':         'transparent'
    },
    shape: {
      'Heart':       "path('M 50 85 C 25 65, 0 45, 0 25 C 0 5, 20 0, 35 0 C 42 0, 50 8, 50 15 C 50 8, 58 0, 65 0 C 80 0, 100 5, 100 25 C 100 45, 75 65, 50 85 Z')",
      'Rectangle':   'inset(0 round 4px)',
      'Rectangular': 'inset(0 round 4px)',
      'Oval':        'ellipse(45% 50%)',
      'Circle':      'circle(50%)',
      'Round':       'circle(50%)',
      'Star':        'polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%)',
      'Arch':        'polygon(0% 100%, 0% 30%, 5% 18%, 15% 8%, 25% 3%, 35% 0.5%, 50% 0%, 65% 0.5%, 75% 3%, 85% 8%, 95% 18%, 100% 30%, 100% 100%)',
      'Diamond':     'polygon(50% 0%, 100% 50%, 50% 100%, 0% 50%)',
      'Classic':     'inset(0 round 4px)',
      'Modern':      'inset(0 round 4px)'
    },
    finish: {
      'Gold':   'radial-gradient(circle, #D4AF37 0%, #B8860B 50%, #DAA520 100%)',
      'Silver': 'radial-gradient(circle, #C0C0C0 0%, #A8A8A8 50%, #D3D3D3 100%)'
    },
    woodBase: {
      'Walnut with LED':  '#5C4033',
      'Maple with LED':   '#C4A882',
      'Black with LED':   '#1a1a1a',
      'No Base':          'transparent',
      'Walnut':           '#5C4033',
      'Maple':            '#C4A882',
      'Beech':            '#D2B48C',
      'Cherry':           '#7B3F00',
      'Black':            '#1a1a1a'
    },
    material: {
      'Canvas': '#d4cfc8',
      'Metal':  'linear-gradient(135deg, #b0b0b0, #d8d8d8, #a0a0a0)',
      'Maple':  '#C4A882',
      'Walnut': '#5C4033',
      'Wood':   '#A0845C'
    },
    style: {
      '3 Panel Set':  'inset(0 round 4px)',
      'Brush Stroke': 'inset(0 round 4px)',
      'Silhouette':   'inset(0 round 4px)',
      'Line Drawing': 'inset(0 round 4px)',
      'Full Color':   'inset(0 round 4px)'
    },
    letterStyle: {
      'Flat':   'none',
      'Raised': 'none',
      '3D':     'none'
    }
  };

  /** Maps property names to which CSS variable and lookup map to use */
  var PROPERTY_TO_CSS = {
    'Frame Color':           { prop: '--ls-frame-color', map: 'frameColor' },
    'Frame Style':           { prop: '--ls-frame-color', map: 'frameColor' },
    'Shape':                 { prop: '--ls-shape',       map: 'shape' },
    'Size & Shape':          { prop: '--ls-shape',       map: 'shape' },
    'Style':                 { prop: '--ls-shape',       map: 'shape' },
    'Finish':                { prop: '--ls-finish-gradient', map: 'finish' },
    'Wood Base & Lighting':  { prop: '--ls-base-color',  map: 'woodBase' },
    'Wood Base':             { prop: '--ls-base-color',  map: 'woodBase' },
    'Colors':                { prop: '--ls-accent-color', map: null },
    'Text Color':            { prop: '--ls-accent-color', map: null },
    'Material':              { prop: '--ls-frame-color', map: 'material' },
    'Art Style':             { prop: '--ls-art-style',    map: 'style' },
    'Color Style':           { prop: '--ls-color-style',  map: 'style' },
    'Letter Style':          { prop: '--ls-letter-style', map: 'letterStyle' },
    'Wood Type':             { prop: '--ls-base-color',   map: 'woodBase' },
    'Lighting':              { prop: '--ls-lighting',     map: null },
    'Frame':                 { prop: '--ls-frame-color',  map: 'frameColor' },
    'Template':              { prop: '--ls-template',     map: null },
    'Canvas Style':          { prop: '--ls-shape',        map: 'style' }
  };

  /* ------------------------------------------------------------------
     Preview type configurations for fabric.js canvas
  ------------------------------------------------------------------ */

  var PREVIEW_CONFIG = {
    /* ---- Product-bg types ----
       photoAreas: array of {left,top,width,height} percentages matching the
       transparent cutouts in each product image. The first area gets the
       interactive fabric.js canvas; additional areas get mirror <img> clones.
       Single-area products have one entry; multi-area products have 2-3.

       swapAreas: keyed by swap-group name, then by swap value → new photoAreas.
       When a swap triggers, photoAreas is replaced with the matching entry. */

    /* ---- "A" print types — share 6 size×orientation images ---- */
    'canvas-print':        { productBg: true, photoAreas: [{left:22.9,top:20.4,width:54.1,height:50.8}],
      swapAreas: { 'print-size': {
        '8x10Landscape': [{left:22.9,top:20.4,width:54.1,height:50.8}],
        '8x10Portrait':  [{left:20.6,top:16.4,width:59.3,height:60.3}],
        '11x14Landscape':[{left:19.3,top:18.9,width:61.1,height:54.3}],
        '11x14Portrait': [{left:17.9,top:11.8,width:63.8,height:64.2}],
        '12x16Landscape':[{left:17.2,top:17.4,width:64.8,height:57.2}],
        '12x16Portrait': [{left:16.5,top:9.6,width:66.6,height:67.4}]
      }}
    },
    'artboard-print':      { productBg: true, photoAreas: [{left:22.9,top:20.4,width:54.1,height:50.8}],
      swapAreas: { 'print-size': {
        '8x10Landscape': [{left:22.9,top:20.4,width:54.1,height:50.8}],
        '8x10Portrait':  [{left:20.6,top:16.4,width:59.3,height:60.3}],
        '11x14Landscape':[{left:19.3,top:18.9,width:61.1,height:54.3}],
        '11x14Portrait': [{left:17.9,top:11.8,width:63.8,height:64.2}],
        '12x16Landscape':[{left:17.2,top:17.4,width:64.8,height:57.2}],
        '12x16Portrait': [{left:16.5,top:9.6,width:66.6,height:67.4}]
      }}
    },
    'temple-canvas':       { productBg: true, photoAreas: [{left:22.9,top:20.4,width:54.1,height:50.8}],
      swapAreas: { 'print-size': {
        '8x10Landscape': [{left:22.9,top:20.4,width:54.1,height:50.8}],
        '8x10Portrait':  [{left:20.6,top:16.4,width:59.3,height:60.3}],
        '11x14Landscape':[{left:19.3,top:18.9,width:61.1,height:54.3}],
        '11x14Portrait': [{left:17.9,top:11.8,width:63.8,height:64.2}],
        '12x16Landscape':[{left:17.2,top:17.4,width:64.8,height:57.2}],
        '12x16Portrait': [{left:16.5,top:9.6,width:66.6,height:67.4}]
      }}
    },
    'metal-print':         { productBg: true, photoAreas: [{left:22.9,top:20.4,width:54.1,height:50.8}],
      swapAreas: { 'print-size': {
        '8x10Landscape': [{left:22.9,top:20.4,width:54.1,height:50.8}],
        '8x10Portrait':  [{left:20.6,top:16.4,width:59.3,height:60.3}],
        '11x14Landscape':[{left:19.3,top:18.9,width:61.1,height:54.3}],
        '11x14Portrait': [{left:17.9,top:11.8,width:63.8,height:64.2}],
        '12x16Landscape':[{left:17.2,top:17.4,width:64.8,height:57.2}],
        '12x16Portrait': [{left:16.5,top:9.6,width:66.6,height:67.4}]
      }}
    },
    'temple-metal-print':  { productBg: true, photoAreas: [{left:22.9,top:20.4,width:54.1,height:50.8}],
      swapAreas: { 'print-size': {
        '8x10Landscape': [{left:22.9,top:20.4,width:54.1,height:50.8}],
        '8x10Portrait':  [{left:20.6,top:16.4,width:59.3,height:60.3}],
        '11x14Landscape':[{left:19.3,top:18.9,width:61.1,height:54.3}],
        '11x14Portrait': [{left:17.9,top:11.8,width:63.8,height:64.2}],
        '12x16Landscape':[{left:17.2,top:17.4,width:64.8,height:57.2}],
        '12x16Portrait': [{left:16.5,top:9.6,width:66.6,height:67.4}]
      }}
    },
    'temple-wood-print':   { productBg: true, photoAreas: [{left:22.9,top:20.4,width:54.1,height:50.8}],
      swapAreas: { 'print-size': {
        '8x10Landscape': [{left:22.9,top:20.4,width:54.1,height:50.8}],
        '8x10Portrait':  [{left:20.6,top:16.4,width:59.3,height:60.3}],
        '11x14Landscape':[{left:19.3,top:18.9,width:61.1,height:54.3}],
        '11x14Portrait': [{left:17.9,top:11.8,width:63.8,height:64.2}],
        '12x16Landscape':[{left:17.2,top:17.4,width:64.8,height:57.2}],
        '12x16Portrait': [{left:16.5,top:9.6,width:66.6,height:67.4}]
      }}
    },
    'missionary-canvas':   { productBg: true, photoAreas: [{left:22.9,top:20.4,width:54.1,height:50.8}],
      swapAreas: { 'print-size': {
        '8x10Landscape': [{left:22.9,top:20.4,width:54.1,height:50.8}],
        '8x10Portrait':  [{left:20.6,top:16.4,width:59.3,height:60.3}],
        '11x14Landscape':[{left:19.3,top:18.9,width:61.1,height:54.3}],
        '11x14Portrait': [{left:17.9,top:11.8,width:63.8,height:64.2}],
        '12x16Landscape':[{left:17.2,top:17.4,width:64.8,height:57.2}],
        '12x16Portrait': [{left:16.5,top:9.6,width:66.6,height:67.4}]
      }}
    },
    'wood-print':          { productBg: true, photoAreas: [{left:22.9,top:20.4,width:54.1,height:50.8}],
      swapAreas: { 'print-size': {
        '8x10Landscape': [{left:22.9,top:20.4,width:54.1,height:50.8}],
        '8x10Portrait':  [{left:20.6,top:16.4,width:59.3,height:60.3}],
        '11x14Landscape':[{left:19.3,top:18.9,width:61.1,height:54.3}],
        '11x14Portrait': [{left:17.9,top:11.8,width:63.8,height:64.2}],
        '12x16Landscape':[{left:17.2,top:17.4,width:64.8,height:57.2}],
        '12x16Portrait': [{left:16.5,top:9.6,width:66.6,height:67.4}]
      }}
    },

    /* ---- Shadow box — orientation swap ---- */
    'shadow-box':          { productBg: true, photoAreas: [{left:26.6,top:30.2,width:49.3,height:43.3}],
      swapAreas: { 'orientation': {
        'landscape': [{left:26.6,top:30.2,width:49.3,height:43.3}],
        'portrait':  [{left:29.3,top:16.9,width:42.6,height:49.1}]
      }}
    },
    'temple-shadow-box':   { productBg: true, photoAreas: [{left:26.6,top:30.2,width:49.3,height:43.3}],
      swapAreas: { 'orientation': {
        'landscape': [{left:26.6,top:30.2,width:49.3,height:43.3}],
        'portrait':  [{left:29.3,top:16.9,width:42.6,height:49.1}]
      }}
    },

    /* ---- Light box — orientation swap ---- */
    'light-box':           { productBg: true, photoAreas: [{left:24.1,top:25.3,width:50.6,height:38.3}],
      swapAreas: { 'orientation': {
        'landscape': [{left:24.1,top:25.3,width:50.6,height:38.3}],
        'portrait':  [{left:27.5,top:17.5,width:45.6,height:47.3}]
      }}
    },

    /* ---- Desktop plaque — style swap (10 styles), multi-photo ---- */
    'desktop-plaque':      { productBg: true, multiPhoto: true,
      photoAreas: [{left:26.8,top:12.1,width:47.8,height:61.6}],
      swapAreas: { 'plaque-style': {
        'style1':  [{left:26.8,top:12.1,width:47.8,height:61.6}],
        'style2':  [
          {left:26.5,top:13.7,width:47.3,height:30.4},
          {left:26.5,top:49.1,width:15.3,height:19.6},
          {left:42.1,top:48.8,width:15.7,height:19.9},
          {left:58.1,top:48.8,width:15.7,height:19.9}
        ],
        'style3':  [{left:31.6,top:13.4,width:37.6,height:41.5}],
        'style4':  [
          {left:23.1,top:22.5,width:26.2,height:39.9},
          {left:50.2,top:22.5,width:28.5,height:18.5},
          {left:49.9,top:42.1,width:29.1,height:20.3}
        ],
        'style5':  [
          {left:18.4,top:16.9,width:31.6,height:14.6},
          {left:50.4,top:16.9,width:32.0,height:14.6},
          {left:18.4,top:31.8,width:16.4,height:24.2},
          {left:35.5,top:31.8,width:28.9,height:24.2,isText:true},
          {left:65.2,top:32.0,width:16.8,height:24.0},
          {left:18.4,top:56.2,width:31.2,height:14.1},
          {left:50.4,top:56.2,width:32.0,height:14.1}
        ],
        'style6':  [
          {left:22.4,top:18.8,width:18.5,height:15.8},
          {left:41.2,top:18.4,width:18.2,height:16.6},
          {left:59.7,top:18.4,width:18.2,height:16.6},
          {left:22.4,top:35.7,width:18.5,height:16.2},
          {left:59.7,top:35.4,width:18.2,height:16.2},
          {left:22.4,top:52.3,width:18.5,height:16.2},
          {left:41.2,top:52.3,width:18.2,height:16.2},
          {left:59.7,top:52.3,width:18.0,height:16.2}
        ],
        'style7':  [
          {left:18.5,top:18.8,width:13.8,height:28.4},
          {left:32.3,top:18.8,width:20.4,height:28.7},
          {left:51.7,top:19.2,width:16.9,height:28.0},
          {left:69.1,top:19.2,width:15.2,height:27.6}
        ],
        'style8':  [{left:23.1,top:17.8,width:54.5,height:47.1}],
        'style9':  [
          {left:22.8,top:22.5,width:18.3,height:16.0},
          {left:41.7,top:22.8,width:18.3,height:15.7},
          {left:60.8,top:22.5,width:18.3,height:16.0},
          {left:22.8,top:52.0,width:18.3,height:15.7},
          {left:41.7,top:52.0,width:18.5,height:15.7},
          {left:60.5,top:51.7,width:18.3,height:16.4}
        ],
        'style10': [
          {left:42.1,top:13.7,width:18.5,height:16.0},
          {left:61.0,top:13.7,width:17.5,height:16.0},
          {left:23.9,top:30.0,width:18.2,height:16.0},
          {left:61.0,top:30.2,width:17.8,height:15.4},
          {left:23.9,top:46.5,width:18.2,height:14.3},
          {left:42.4,top:46.5,width:17.8,height:14.3}
        ]
      }}
    },

    /* ---- Missionary desktop & Temple LED desktop — orientation swap ---- */
    'missionary-desktop':  { productBg: true, photoAreas: [{left:21.5,top:20.7,width:58.8,height:49.4}],
      swapAreas: { 'orientation': {
        'landscape': [{left:21.5,top:20.7,width:58.8,height:49.4}],
        'portrait':  [{left:26.7,top:11.9,width:47.8,height:61.6}]
      }}
    },
    'temple-desktop-light':{ productBg: true, photoAreas: [{left:21.5,top:20.7,width:58.8,height:49.4}],
      swapAreas: { 'orientation': {
        'landscape': [{left:21.5,top:20.7,width:58.8,height:49.4}],
        'portrait':  [{left:26.7,top:11.9,width:47.8,height:61.6}]
      }}
    },

    /* ---- Children's nightlight — style swap (3 room images) ---- */
    'childrens-night-light':{ productBg: true, photoAreas: [{left:42.7,top:37.4,width:29.5,height:22.8}],
      swapAreas: { 'nightlight-style': {
        'room1': [{left:42.7,top:37.4,width:29.5,height:22.8}],
        'room2': [{left:32.1,top:30.4,width:37.9,height:30.1}],
        'room3': [{left:29.9,top:31.8,width:40.2,height:31.4}]
      }}
    },

    /* ---- Missionary plaque ---- */
    'missionary-plaque':   { productBg: true, photoAreas: [{left:11.1,top:26.7,width:16.0,height:37.6}] },

    /* ---- Puzzles — compound swap: Size variant + Orientation ---- */
    'puzzle':              { productBg: true, photoAreas: [{left:42.9,top:16.1,width:49.7,height:55.9}],
      swapAreas: { 'puzzle-variant': {
        '5x7Landscape':  [{left:10.0,top:31.8,width:30.3,height:37.4}],
        '5x7Portrait':   [{left:15.0,top:26.4,width:25.1,height:52.9}],
        '8x10Landscape': [{left:42.9,top:16.1,width:49.7,height:55.9}],
        '8x10Portrait':  [{left:45.4,top:5.7,width:39.4,height:73.7}],
        '11x14Landscape':[{left:4.4,top:30.6,width:38.2,height:42.0}],
        '11x14Portrait': [{left:14.8,top:21.9,width:29.0,height:59.3}],
        '12x16Landscape':[{left:45.4,top:27.1,width:51.0,height:51.3}],
        '12x16Portrait': [{left:47.5,top:9.6,width:37.6,height:72.2}],
        '5Round':        [{left:13.3,top:36.2,width:28.1,height:43.4}],
        '8Round':        [{left:45.4,top:13.3,width:45.3,height:66.9}],
        '12Round':       [{left:13.5,top:11.8,width:73.0,height:74.7}]
      }}
    },
    'temple-puzzle':       { productBg: true, photoAreas: [{left:42.9,top:16.1,width:49.7,height:55.9}],
      swapAreas: { 'puzzle-variant': {
        '5x7Landscape':  [{left:10.0,top:31.8,width:30.3,height:37.4}],
        '5x7Portrait':   [{left:15.0,top:26.4,width:25.1,height:52.9}],
        '8x10Landscape': [{left:42.9,top:16.1,width:49.7,height:55.9}],
        '8x10Portrait':  [{left:45.4,top:5.7,width:39.4,height:73.7}],
        '11x14Landscape':[{left:4.4,top:30.6,width:38.2,height:42.0}],
        '11x14Portrait': [{left:14.8,top:21.9,width:29.0,height:59.3}],
        '12x16Landscape':[{left:45.4,top:27.1,width:51.0,height:51.3}],
        '12x16Portrait': [{left:47.5,top:9.6,width:37.6,height:72.2}],
        '5Round':        [{left:13.3,top:36.2,width:28.1,height:43.4}],
        '8Round':        [{left:45.4,top:13.3,width:45.3,height:66.9}],
        '12Round':       [{left:13.5,top:11.8,width:73.0,height:74.7}]
      }}
    },

    /* ---- Vinyl record — size swap ---- */
    'vinyl-record':        { productBg: true, photoAreas: [{left:17.8,top:14.4,width:35.8,height:55.9}],
      swapAreas: { 'vinyl-size': {
        '7':  [{left:63.4,top:31.1,width:19.4,height:30.6}],
        '12': [{left:17.8,top:14.4,width:35.8,height:55.9}]
      }}
    },

    /* ---- Canvas 3-panel — size swap (18"/36") ---- */
    // lockPhoto: the photo is placed automatically and cannot be dragged, zoomed
    // or rotated. The control buttons are not rendered for this type either (see
    // the {%- unless -%} around .ls-preview__controls in the section).
    'canvas-three-panel':  { productBg: true, splitPhoto: 3, lockPhoto: true, photoAreas: [
      {left:13.3,top:28.3,width:10.1,height:35.5},
      {left:24.2,top:28.3,width:10.2,height:35.5},
      {left:35.3,top:28.3,width:10.1,height:35.4}
    ],
      swapAreas: { 'panel-size': {
        '18': [{left:13.3,top:28.3,width:10.1,height:35.5},{left:24.2,top:28.3,width:10.2,height:35.5},{left:35.3,top:28.3,width:10.1,height:35.4}],
        '36': [{left:50.8,top:12.7,width:11.6,height:64.5},{left:63.2,top:12.7,width:11.7,height:64.6},{left:75.9,top:12.7,width:11.6,height:64.5}]
      }}
    },

    /* ---- Sports displays — individual/team swap ---- */
    'sports-display':      { productBg: true, photoAreas: [{left:16.7,top:16.3,width:28.7,height:44.5}],
      swapAreas: { 'sports-mode': {
        'individual': [{left:16.7,top:16.3,width:28.7,height:44.5}],
        'team':       [{left:13.4,top:16.5,width:30.6,height:47.9}]
      }}
    },
    'sports-wall-display': { productBg: true, photoAreas: [{left:19.4,top:20.2,width:24.7,height:38.9}],
      swapAreas: { 'sports-mode': {
        'individual': [{left:19.4,top:20.2,width:24.7,height:38.9}],
        'team':       [{left:17.4,top:20.4,width:26.7,height:41.9}]
      }}
    },

    /* ---- Acrylic block — per-size/shape swap ---- */
    'acrylic-block':       { productBg: true, photoAreas: [{left:54.3,top:23.6,width:33.9,height:51.2}],
      swapAreas: { 'acrylic-shape': {
        '2Square':      [{left:12.7,top:57.4,width:8.0,height:14.3}],
        '3Square':      [{left:25.0,top:46.9,width:13.3,height:24.8}],
        '4Square':      [{left:42.7,top:42.7,width:17.0,height:29.1}],
        '6Square':      [{left:65.4,top:23.5,width:24.5,height:47.4}],
        '2Round':       [{left:21.8,top:36.5,width:21.2,height:36.2}],
        // 3Round and 4Round measured Sep 15 from the mockups themselves: the
        // window is the blank disc, and its bounding box was read off the pixels
        // rather than estimated. Both came out as near-perfect circles
        // (width/height within 1.5%), which is the check that the box is right.
        //
        // 3Round previously read {47.2, 22.9, 30.8, 51.5}. That no longer matches
        // ls-bg-acrylic-3-round.png — the mockups were rebuilt (the Sep 1 call
        // notes squaring up the blank previews) and these numbers were never
        // re-measured, so the photo was landing off the disc.
        '3Round':       [{left:54.6,top:35.9,width:22.8,height:30.8}],
        '4Round':       [{left:18.8,top:26.9,width:31.1,height:41.4}],
        'heart':        [{left:54.3,top:23.6,width:33.9,height:51.2}],
        'heartStand':   [{left:15.9,top:23.2,width:35.3,height:53.0}],
        'puzzleSingle': [{left:7.6,top:34.0,width:27.7,height:39.0}],
        'puzzleDouble': [{left:38.7,top:32.5,width:53.0,height:40.5}]
      }}
    },

    /* ---- Unchanged single-area products ---- */
    'school-frame':        { productBg: true, photoAreas: [{left:26.1,top:12.0,width:50.0,height:49.0}] },
    'shadow-box-missionary':{ productBg: true, photoAreas: [{left:26.6,top:30.2,width:49.3,height:43.3}],
      swapAreas: { 'orientation': {
        'landscape': [{left:26.6,top:30.2,width:49.3,height:43.3}],
        'portrait':  [{left:29.3,top:16.9,width:42.6,height:49.1}]
      }}
    },
    'shadow-box-sport':    { productBg: true, photoAreas: [{left:26.6,top:30.2,width:49.3,height:43.3}],
      swapAreas: { 'orientation': {
        'landscape': [{left:26.6,top:30.2,width:49.3,height:43.3}],
        'portrait':  [{left:29.3,top:16.9,width:42.6,height:49.1}]
      }}
    },
    'wood-stand':          { productBg: true, photoAreas: [{left:22.3,top:29.0,width:52.9,height:49.4}] },
    'desktop-portrait':    { productBg: true, photoAreas: [{left:26.1,top:5.7,width:50.7,height:76.6}] },
    'temple-nightlight':   { productBg: true, photoAreas: [{left:17.7,top:21.9,width:29.3,height:36.6}] },
    'sports-wall':         { productBg: true, photoAreas: [{left:19.4,top:20.2,width:24.7,height:38.9}],
      swapAreas: { 'sports-mode': {
        'individual': [{left:19.4,top:20.2,width:24.7,height:38.9}],
        'team':       [{left:17.4,top:20.4,width:26.7,height:41.9}]
      }}
    },

    /* ---- Coin (dual-canvas, existing pattern) ---- */
    'coin': {
      aspect: 1,
      clipShape: 'circle',
      clipRadius: 0.5, // was 0.36 when rim gradient was drawn — now full circle since coin images include the rim
      photoWindow: null,
      coinAreas: {
        'photo':         { front: {left:20.6, top:50.2, width:22.9}, back: {left:56.0, top:50.9, width:22.4} },
        'missionary':    { front: {left:20.5, top:45.6, width:22.5}, back: null },
        'temple':        { front: {left:14.6, top:44.7, width:27.6}, back: {left:60.3, top:45.1, width:27.0} },
        'sports':               { front: {left:15.2, top:40.8, width:24.9}, back: null },
        'cruise':               { front: {left:15.3, top:38.9, width:26.0}, back: null },
        'temple-commemorative': { front: {left:12.4, top:50.8, width:31.3}, back: null },
        'challenge-sobriety':   { front: {left:20.6, top:50.2, width:22.9}, back: {left:56.0, top:50.9, width:22.4} },
        'personalized-photo':   { front: {left:20.6, top:50.2, width:22.9}, back: {left:56.0, top:50.9, width:22.4} }
      }
    }
  };

  class LsPreview {
    constructor(root) {
      this.root = root;
      this.previewEl = qs('.ls-preview', root);
      if (!this.previewEl) return;

      this.type = this.previewEl.dataset.previewType;
      this.config = PREVIEW_CONFIG[this.type] || { aspect: 1, photoWindow: null };
      this.controlsEl = qs('.ls-preview__controls', this.previewEl);

      // Canvas references (initialized after fabric.js loads)
      this.canvas = null;
      this.backCanvas = null;
      this.photoImage = null;
      this.backPhotoImage = null;
      this._activeFace = 'front';

      this._mirrors = []; // mirror fabric.js canvases for multi-area products
      this._mirrorPhotos = []; // photo images on mirror canvases
      this._photoDataUrl = null; // last uploaded photo data URL

      this._relocatePreview();
      this._positionFrame();
      this._initCoinFramePositions();
      this._bindCloseButton();
      this._waitForFabric();
      this._bindOptionChanges();
      this._bindCoinToggle();
      // this._bindCoinTextInputs(); // COMMENTED OUT: coin images now include text placeholders
      // this._bindTextOverlay(); // COMMENTED OUT: preview images now include text placeholders
    }

    /** Wait for fabric.js to load (it's deferred), then initialize canvases */
    _waitForFabric() {
      var self = this;

      function onReady() {
        self._initCanvases();
        self._bindPhotoUploads();
        self._bindControls();
      }

      if (typeof fabric !== 'undefined') {
        onReady();
        return;
      }
      var attempts = 0;
      var poll = setInterval(function () {
        attempts++;
        if (typeof fabric !== 'undefined') {
          clearInterval(poll);
          onReady();
        } else if (attempts > 100) {
          clearInterval(poll);
        }
      }, 100);
    }

    /** Position the canvas frame at the first photoArea and create mirror elements */
    _positionFrame() {
      var areas = this.config.photoAreas;
      if (!areas || !areas.length) return;
      dbg('_positionFrame — areas:', areas.length, 'multiPhoto:', this.config.multiPhoto, 'type:', this.type);

      var frameEl = qs('.ls-preview__frame', qs('.ls-preview__product-bg', this.previewEl));
      if (!frameEl) return;

      // Position canvas frame at first area
      var a = areas[0];
      frameEl.style.left   = a.left + '%';
      frameEl.style.top    = a.top + '%';
      frameEl.style.width  = a.width + '%';
      frameEl.style.height = a.height + '%';

      // Keep text overlay aligned with the frame and reset drag
      if (this._textOverlayEl) {
        this._textOverlayEl.style.left   = (a.left + a.width / 2) + '%';
        this._textOverlayEl.style.bottom = (100 - a.top - a.height + 4) + '%';
        if (this._textOverlayEl._lsResetDrag) this._textOverlayEl._lsResetDrag();
      }

      // Create mirror canvas elements for additional areas (hidden until photo uploaded)
      // Areas marked with isText:true get a text display div instead of a canvas
      var container = qs('.ls-preview__product-bg', this.previewEl);
      if (this._plaqueTextAreaEl) {
        this._plaqueTextAreaEl.remove();
        this._plaqueTextAreaEl = null;
      }
      for (var i = 1; i < areas.length; i++) {
        var m = areas[i];
        if (m.isText) {
          // Create a text display element instead of a mirror canvas
          var textDiv = document.createElement('div');
          textDiv.className = 'ls-preview__plaque-text-area';
          textDiv.style.cssText = 'position:absolute;z-index:2;overflow:hidden;'
            + 'display:flex;flex-direction:column;align-items:center;justify-content:center;'
            + 'left:' + m.left + '%;top:' + m.top + '%;width:' + m.width + '%;height:' + m.height + '%;'
            + 'pointer-events:none;text-align:center;color:#fff;';
          container.appendChild(textDiv);
          this._plaqueTextAreaEl = textDiv;
          this._bindPlaqueTextArea();
          continue;
        }
        var wrapper = document.createElement('div');
        wrapper.className = 'ls-preview__frame ls-preview__mirror';
        wrapper.style.cssText = 'position:absolute;z-index:1;display:none;overflow:hidden;'
          + 'left:' + m.left + '%;top:' + m.top + '%;width:' + m.width + '%;height:' + m.height + '%;';
        var cvs = document.createElement('canvas');
        cvs.className = 'ls-preview__canvas';
        cvs.setAttribute('data-face', 'mirror-' + i);
        wrapper.appendChild(cvs);
        container.appendChild(wrapper);
        this._mirrors.push({ wrapper: wrapper, canvasEl: cvs, fabricCanvas: null });
      }

      // Click-to-activate: main frame → active, mirrors → active
      var self = this;
      if (frameEl) {
        frameEl.addEventListener('click', function () { self._setActiveMirror(null); });
      }
      this._mirrors.forEach(function (m, idx) {
        m.wrapper.addEventListener('click', function () { self._setActiveMirror(idx); });
      });
    }

    /** Bind text inputs to the plaque text area (Style 5 center slot) */
    _bindPlaqueTextArea() {
      if (!this._plaqueTextAreaEl) return;
      var self = this;
      var excludeProps = ['silhouette', 'cutout', 'photo description', 'gift message', '_preview'];

      // Search both the customizer root and relocated container
      var getRoots = function () {
        var roots = [self.root];
        var relocated = document.querySelector('.ls-customizer-relocated');
        if (relocated) roots.push(relocated);
        return roots;
      };

      var update = function () {
        if (!self._plaqueTextAreaEl) return;
        var roots = getRoots();
        var lines = [];
        var fontFamily = '';

        // Find selected font across all roots
        roots.forEach(function (root) {
          var fontRadios = qsa('input[type="radio"]:checked', root);
          for (var fi = 0; fi < fontRadios.length; fi++) {
            var fpn = (fontRadios[fi].name || '').replace('properties[', '').replace(']', '').toLowerCase();
            if (fpn.indexOf('font') !== -1) {
              fontFamily = fontRadios[fi].value;
              break;
            }
          }
        });

        // Find text inputs across all roots
        roots.forEach(function (root) {
          qsa('input[type="text"], textarea', root).forEach(function (input) {
            var cond = input.closest('.ls-conditional');
            if (cond && !cond.classList.contains('is-active')) return;
            var parentCond = cond ? cond.parentElement.closest('.ls-conditional') : null;
            if (parentCond && !parentCond.classList.contains('is-active')) return;
            var name = (input.name || '').replace('properties[', '').replace(']', '');
            var nameLower = name.toLowerCase();
            for (var ei = 0; ei < excludeProps.length; ei++) {
              if (nameLower.indexOf(excludeProps[ei]) !== -1) return;
            }
            var val = input.value.trim();
            if (val) lines.push(val);
          });
        });

        self._plaqueTextAreaEl.innerHTML = '';
        for (var li = 0; li < lines.length; li++) {
          var div = document.createElement('div');
          div.className = 'ls-preview__plaque-text-line';
          div.textContent = lines[li];
          if (fontFamily) {
            div.style.fontFamily = '"' + fontFamily + '", sans-serif';
          }
          self._plaqueTextAreaEl.appendChild(div);
        }
      };

      // Bind to all text inputs and font radios across all roots
      var bindInputs = function () {
        getRoots().forEach(function (root) {
          qsa('input[type="text"], textarea', root).forEach(function (input) {
            if (input._lsPlaqueTextBound) return;
            input._lsPlaqueTextBound = true;
            input.addEventListener('input', update);
          });
          qsa('input[type="radio"]', root).forEach(function (radio) {
            if (radio._lsPlaqueTextBound) return;
            radio._lsPlaqueTextBound = true;
            radio.addEventListener('change', update);
          });
        });
      };

      bindInputs();

      // Re-bind when DOM changes (conditional steps revealed, relocation, etc.)
      var observeRoot = function (root) {
        var observer = new MutationObserver(function () {
          bindInputs();
          update();
        });
        observer.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
      };
      getRoots().forEach(observeRoot);
    }

    /** Compute mirror pixel dimensions from parent container + percentage area */
    _getMirrorDimensions(mirror) {
      // Try wrapper dimensions first
      var w = mirror.wrapper.clientWidth;
      var h = mirror.wrapper.clientHeight;
      if (w && h) {
        dbg('  _getMirrorDimensions — from wrapper:', w + 'x' + h);
        return { width: w, height: h };
      }

      // Fallback: calculate from parent container dimensions and inline % values
      var container = mirror.wrapper.parentElement;
      if (!container) { dbg('  _getMirrorDimensions — no parent, returning null'); return null; }
      var cw = container.clientWidth;
      var ch = container.clientHeight;

      // If the container has width but no height, the bg image likely hasn't
      // given the container its intrinsic height yet (width:100%; height:auto).
      // Compute the expected height from the image's natural aspect ratio.
      if (cw && !ch) {
        var bgImg = container.querySelector('.ls-preview__product-bg-img');
        if (bgImg && bgImg.naturalWidth && bgImg.naturalHeight) {
          ch = Math.round(cw * bgImg.naturalHeight / bgImg.naturalWidth);
          dbg('  _getMirrorDimensions — computed ch from img aspect ratio:', bgImg.naturalWidth + 'x' + bgImg.naturalHeight, '→ ch=' + ch);
        } else if (bgImg && !bgImg.naturalWidth) {
          // Image hasn't loaded yet (possibly loading="lazy" and off-screen).
          // Force it to load so retries can pick it up.
          bgImg.loading = 'eager';
          dbg('  _getMirrorDimensions — bg image not loaded yet, forced eager loading');
        }
      }

      if (!cw || !ch) { dbg('  _getMirrorDimensions — container has no dims:', cw + 'x' + ch); return null; }

      var pctW = parseFloat(mirror.wrapper.style.width) || 50;
      var pctH = parseFloat(mirror.wrapper.style.height) || 50;
      var result = {
        width: Math.round(cw * pctW / 100),
        height: Math.round(ch * pctH / 100)
      };
      dbg('  _getMirrorDimensions — fallback from container:', cw + 'x' + ch, '× pct:', pctW + '%x' + pctH + '% =', result.width + 'x' + result.height);
      return result;
    }

    /** Initialize a single mirror's fabric.js canvas */
    _initSingleMirror(m) {
      if (m.fabricCanvas) { dbg('  _initSingleMirror — already has fabricCanvas, skipping'); return; }
      var dims = this._getMirrorDimensions(m);
      if (!dims) { dbg('  _initSingleMirror — _getMirrorDimensions returned null'); return; }
      dbg('  _initSingleMirror — creating fabric canvas at', dims.width + 'x' + dims.height);
      m.canvasEl.width = dims.width;
      m.canvasEl.height = dims.height;
      m.fabricCanvas = new fabric.Canvas(m.canvasEl, {
        selection: false,
        renderOnAddRemove: true,
        allowTouchScrolling: false
      });
      m.fabricCanvas.setDimensions({ width: dims.width, height: dims.height });

      // Activate this mirror when tapped/clicked so controls target it.
      // The wrapper's click listener may not fire because Fabric's upper
      // canvas element sits on top and consumes pointer events.
      var self = this;
      var mirrorIdx = this._mirrors.indexOf(m);
      m.fabricCanvas.on('mouse:down', function () {
        self._setActiveMirror(mirrorIdx);
      });
    }

    /** Initialize fabric.js on all visible mirror canvases */
    _initMirrorCanvases() {
      for (var i = 0; i < this._mirrors.length; i++) {
        this._initSingleMirror(this._mirrors[i]);
      }
    }

    /** Add a photo to a single mirror canvas, fitting it to cover the area */
    _addPhotoToMirror(idx, mirror, dataUrl) {
      var self = this;
      fabric.FabricImage.fromURL(dataUrl).then(function (img) {
        var cw = mirror.fabricCanvas.width;
        var ch = mirror.fabricCanvas.height;

        // splitPhoto: crop the image into N vertical slices (idx+1 because main canvas = slice 0)
        var splits = self.config.splitPhoto || 0;
        if (splits > 1) {
          var sliceIdx = idx + 1; // mirror 0 = slice 1, mirror 1 = slice 2, etc.
          var sliceW = Math.floor(img.width / splits);
          img.set({
            cropX: sliceW * sliceIdx,
            cropY: 0,
            width: sliceW,
            height: img.height
          });
        }

        var scaleX = cw / img.width;
        var scaleY = ch / img.height;
        var scale = Math.max(scaleX, scaleY);

        img.set({
          scaleX: scale,
          scaleY: scale,
          left: cw / 2,
          top: ch / 2,
          originX: 'center',
          originY: 'center',
          selectable: true,
          hasControls: true,
          hasBorders: true,
          lockUniScaling: true,
          cornerSize: 20,
          touchCornerSize: 44,
          cornerColor: '#c8a45d',
          cornerStrokeColor: '#fff',
          cornerStyle: 'circle',
          borderColor: '#c8a45d',
          transparentCorners: false,
          padding: 0
        });

        // Products with lockPhoto show the photo exactly as placed and give the
        // customer no way to move it. On the three-panel canvas one photo is
        // split across three canvases, so any hand positioning has to be applied
        // to all three to stay aligned — simpler to fix the placement than to
        // offer a control that only makes sense when it is mirrored.
        // evented:false also stops the panel picking up click/selection events,
        // so no selection handles ever appear.
        if (self.config.lockPhoto) {
          img.set({
            selectable: false,
            evented: false,
            hasControls: false,
            hasBorders: false,
            lockMovementX: true,
            lockMovementY: true,
            lockScalingX: true,
            lockScalingY: true,
            lockRotation: true
          });
        }

        dbg('  _addPhotoToMirror[' + idx + '] — img loaded, canvas:', mirror.fabricCanvas.width + 'x' + mirror.fabricCanvas.height, 'img:', img.width + 'x' + img.height, 'scale:', img.scaleX);
        mirror.fabricCanvas.add(img);
        mirror.fabricCanvas.setActiveObject(img);
        mirror.fabricCanvas.renderAll();
        forceCanvasRepaint(mirror.fabricCanvas);
        self._mirrorPhotos[idx] = img;
        dbg('  _addPhotoToMirror[' + idx + '] — rendered + forceRepaint done. Objects on canvas:', mirror.fabricCanvas.getObjects().length);

        // Double-RAF: ensures the compositor has fully
        // committed before re-rendering + nudging dimensions
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            if (!mirror.fabricCanvas) return;
            dbg('  _addPhotoToMirror[' + idx + '] — double-RAF repaint. Canvas objects:', mirror.fabricCanvas.getObjects().length, 'dims:', mirror.fabricCanvas.width + 'x' + mirror.fabricCanvas.height);
            mirror.fabricCanvas.setDimensions({
              width: mirror.fabricCanvas.width,
              height: mirror.fabricCanvas.height
            });
            mirror.fabricCanvas.renderAll();
            forceCanvasRepaint(mirror.fabricCanvas);
          });
        });
      });
    }

    /** Show the uploaded photo in all mirror areas */
    _updateMirrors(dataUrl) {
      this._photoDataUrl = dataUrl;
      var self = this;

      for (var i = 0; i < this._mirrors.length; i++) {
        var m = this._mirrors[i];
        // Show/hide wrapper
        m.wrapper.style.display = dataUrl ? '' : 'none';
        if (!dataUrl) continue;

        // Remove old photo if any
        if (m.fabricCanvas && self._mirrorPhotos[i]) {
          m.fabricCanvas.remove(self._mirrorPhotos[i]);
          self._mirrorPhotos[i] = null;
        }

        // Initialize or resize — defer to ensure wrapper is visible and has layout
        (function(idx, mirror, url) {
          var retries = 0;
          function tryInit() {
            var dims = self._getMirrorDimensions(mirror);
            if (!dims && retries < 60) {
              retries++;
              setTimeout(tryInit, retries < 10 ? 50 : 150);
              return;
            }
            if (!dims) return;

            // First-time init
            if (!mirror.fabricCanvas) {
              self._initSingleMirror(mirror);
            }
            if (!mirror.fabricCanvas) return;

            // Resize if dimensions changed
            if (mirror.fabricCanvas.width !== dims.width || mirror.fabricCanvas.height !== dims.height) {
              mirror.fabricCanvas.setDimensions({ width: dims.width, height: dims.height });
            }

            self._addPhotoToMirror(idx, mirror, url);
          }
          // Use requestAnimationFrame + setTimeout to ensure layout is computed
          requestAnimationFrame(function() { setTimeout(tryInit, 20); });
        })(i, m, dataUrl);
      }
    }

    /** Sync drag across all split-photo panels so they move as one image */
    /**
     * Mirror the active panel's placement onto every other panel.
     *
     * For splitPhoto products each canvas holds a different vertical slice of
     * the same photo, so the slices only line up while all the panels share the
     * same position, scale and angle. Position is carried as a fraction of each
     * canvas rather than in pixels, because the panels are not all the same
     * width — the same reason _bindSplitSync() works in percentages.
     *
     * Angle is included here and not in _bindSplitSync: dragging and scaling
     * cannot rotate the photo, but the rotate button can, and a single rotated
     * panel breaks the picture across the set.
     *
     * No-op on every other product type.
     */
    _syncSplitPanels() {
      if (!this.config.splitPhoto || this.config.splitPhoto < 2) return;
      if (this._splitSyncing) return;

      var srcCanvas = this._getActiveCanvas();
      var srcPhoto = this._getActivePhoto();
      if (!srcCanvas || !srcPhoto || !srcCanvas.width || !srcCanvas.height) return;

      this._splitSyncing = true;

      var pctLeft = srcPhoto.left / srcCanvas.width;
      var pctTop = srcPhoto.top / srcCanvas.height;
      var sX = srcPhoto.scaleX;
      var sY = srcPhoto.scaleY;
      var angle = srcPhoto.angle;

      var targets = [];
      if (this.canvas && this.photoImage) {
        targets.push({ fc: this.canvas, photo: this.photoImage });
      }
      for (var i = 0; i < this._mirrors.length; i++) {
        if (this._mirrors[i].fabricCanvas && this._mirrorPhotos[i]) {
          targets.push({ fc: this._mirrors[i].fabricCanvas, photo: this._mirrorPhotos[i] });
        }
      }

      for (var t = 0; t < targets.length; t++) {
        if (targets[t].photo === srcPhoto) continue;
        targets[t].photo.set({
          left: pctLeft * targets[t].fc.width,
          top: pctTop * targets[t].fc.height,
          scaleX: sX,
          scaleY: sY,
          angle: angle
        });
        targets[t].photo.setCoords();
        targets[t].fc.renderAll();
      }

      this._splitSyncing = false;
    }

    _bindSplitSync() {
      if (!this.config.splitPhoto || this.config.splitPhoto < 2) return;
      // Nothing to keep in sync when the photo cannot be moved. Skipping this
      // also matters because its mouse:down handler turns selection handles back
      // on for the panel that was clicked, which would undo the lock.
      if (this.config.lockPhoto) return;
      var self = this;
      if (this._splitSyncBound) return;
      this._splitSyncBound = true;

      // Collect all canvases: main (index -1) + mirrors (index 0, 1, ...)
      function getAllCanvases() {
        var list = [];
        if (self.canvas) list.push({ fc: self.canvas, photo: self.photoImage, idx: -1 });
        for (var i = 0; i < self._mirrors.length; i++) {
          if (self._mirrors[i].fabricCanvas) {
            list.push({ fc: self._mirrors[i].fabricCanvas, photo: self._mirrorPhotos[i], idx: i });
          }
        }
        return list;
      }

      function onSync(sourceIdx, e) {
        if (self._splitSyncing) return;
        self._splitSyncing = true;
        var obj = e.target;
        var sourceCanvas = sourceIdx === -1 ? self.canvas : self._mirrors[sourceIdx].fabricCanvas;
        // Calculate position and scale as % of canvas
        var pctLeft = obj.left / sourceCanvas.width;
        var pctTop = obj.top / sourceCanvas.height;
        var sX = obj.scaleX;
        var sY = obj.scaleY;

        var all = getAllCanvases();
        for (var i = 0; i < all.length; i++) {
          if (all[i].idx === sourceIdx) continue;
          var photo = all[i].idx === -1 ? self.photoImage : self._mirrorPhotos[all[i].idx];
          if (!photo) continue;
          photo.set({
            left: pctLeft * all[i].fc.width,
            top: pctTop * all[i].fc.height,
            scaleX: sX,
            scaleY: sY,
            hasControls: false,
            hasBorders: false
          });
          photo.setCoords();
          all[i].fc.discardActiveObject();
          all[i].fc.renderAll();
        }
        self._splitSyncing = false;
      }

      // When a panel is selected, show controls only on that panel
      function onSelected(sourceIdx) {
        var all = getAllCanvases();
        for (var i = 0; i < all.length; i++) {
          var photo = all[i].idx === -1 ? self.photoImage : self._mirrorPhotos[all[i].idx];
          if (!photo) continue;
          if (all[i].idx === sourceIdx) {
            photo.set({ hasControls: true, hasBorders: true });
            all[i].fc.setActiveObject(photo);
          } else {
            photo.set({ hasControls: false, hasBorders: false });
            all[i].fc.discardActiveObject();
          }
          all[i].fc.renderAll();
        }
      }

      function bindCanvas(fc, idx) {
        fc.on('object:moving', function(e) { onSync(idx, e); });
        fc.on('object:scaling', function(e) { onSync(idx, e); });
        fc.on('selection:created', function() { onSelected(idx); });
        fc.on('mouse:down', function() { onSelected(idx); });
      }

      // Bind to main canvas
      if (this.canvas) {
        bindCanvas(this.canvas, -1);
      }
      // Bind to mirrors (re-bind when mirrors are initialized)
      var origInit = this._initSingleMirror.bind(this);
      var self2 = this;
      this._initSingleMirror = function(m) {
        origInit(m);
        if (m.fabricCanvas && !m._splitBound) {
          m._splitBound = true;
          var mIdx = self2._mirrors.indexOf(m);
          bindCanvas(m.fabricCanvas, mIdx);
        }
      };
    }

    /** Clear mirrors when photo is removed */
    _clearMirrors() {
      this._photoDataUrl = null;
      for (var i = 0; i < this._mirrors.length; i++) {
        var m = this._mirrors[i];
        m.wrapper.style.display = 'none';
        if (m.fabricCanvas && this._mirrorPhotos[i]) {
          m.fabricCanvas.remove(this._mirrorPhotos[i]);
          m.fabricCanvas.renderAll();
        }
      }
      this._mirrorPhotos = [];
    }

    _initCanvases() {
      var frontCanvasEl = qs('.ls-preview__canvas[data-face="front"]', this.previewEl);
      if (!frontCanvasEl) return;

      this.canvas = this._createCanvas(frontCanvasEl);

      // Clicking the main canvas resets active target back to photo 1
      var self = this;
      this.canvas.on('mouse:down', function () {
        self._setActiveMirror(null);
      });

      // Back canvas for coins
      var backCanvasEl = qs('.ls-preview__canvas--back', this.previewEl);
      if (backCanvasEl) {
        this.backCanvas = this._createCanvas(backCanvasEl);
      }
      // Mirror canvases are initialized lazily in _updateMirrors when visible

      // Sync drag across split-photo panels (e.g. 3-panel canvas)
      this._bindSplitSync();
    }

    _createCanvas(canvasEl) {
      var frameEl = canvasEl.closest('.ls-preview__frame');
      var width = frameEl.clientWidth || 320;
      var height;

      if (this.config.productBg) {
        // Product-bg types: read actual frame dimensions from CSS positioning
        height = frameEl.clientHeight || width;
      } else {
        height = Math.round(width / (this.config.aspect || 1));
      }

      canvasEl.width = width;
      canvasEl.height = height;

      var bgColor = (this.type === 'coin' || this.config.productBg) ? 'transparent' : '#e5e1dc';
      var canvas = new fabric.Canvas(canvasEl, {
        width: width,
        height: height,
        backgroundColor: bgColor,
        selection: false,
        allowTouchScrolling: true,
        controlsAboveOverlay: false
      });

      // Draw decorative elements for specific types (skipped for product-bg)
      if (!this.config.productBg) {
        this._drawDecorations(canvas);
      }

      return canvas;
    }

    /** Draw per-type decorations (borders, coin rim, vinyl grooves, etc.) */
    _drawDecorations(canvas) {
      var w = canvas.width;
      var h = canvas.height;

      if (this.config.border) {
        var bw = this.config.border.width;
        var color = this.config.border.colorFixed
          || getComputedStyle(this.previewEl).getPropertyValue(this.config.border.colorVar).trim()
          || '#1a1a1a';
        var borderRect = new fabric.Rect({
          left: 0, top: 0, width: w, height: h,
          fill: 'transparent',
          stroke: color,
          strokeWidth: bw * 2,
          selectable: false, evented: false
        });
        canvas.add(borderRect);
        canvas.bringObjectToFront(borderRect);
        // Store reference for color updates
        canvas._lsBorderRect = borderRect;
      }

      /* --- COMMENTED OUT: coin images now include the rim border ---
      // Coin metallic rim — brushed antique gold
      if (this.type === 'coin') {
        var rimR = w / 2;
        var gradient = new fabric.Gradient({
          type: 'radial',
          coords: { x1: rimR, y1: rimR, r1: rimR * 0.65, x2: rimR, y2: rimR, r2: rimR },
          colorStops: LsPreview.COIN_GOLD_STOPS
        });
        var rim = new fabric.Circle({
          left: 0, top: 0, radius: rimR,
          fill: gradient,
          stroke: '#6B5418',
          strokeWidth: 1,
          selectable: false, evented: false
        });
        canvas.add(rim);
        canvas.sendObjectToBack(rim);
        canvas._lsCoinRim = rim;
      }
      --- END COMMENTED OUT */

      // Vinyl record grooves
      if (this.type === 'vinyl-record') {
        var vinylBg = new fabric.Circle({
          left: 0, top: 0, radius: w / 2,
          fill: '#1a1a1a',
          selectable: false, evented: false
        });
        canvas.add(vinylBg);
        canvas.sendObjectToBack(vinylBg);
        // Center hole
        var hole = new fabric.Circle({
          left: w / 2 - w * 0.03, top: h / 2 - h * 0.03,
          radius: w * 0.03,
          fill: '#e5e1dc',
          selectable: false, evented: false
        });
        canvas.add(hole);
        canvas.bringObjectToFront(hole);
        canvas._lsVinylHole = hole;
      }
    }

    /** Move the preview into the product media column, hidden initially */
    _relocatePreview() {
      if (!this.previewEl) return;

      var isMobile = window.matchMedia('(max-width: 749px)').matches;

      if (isMobile) {
        // On mobile, insert preview right after the progress bar so users
        // see it while filling in steps without scrolling back up.
        var progressBar = document.querySelector('.ls-customizer-relocated .ls-progress')
          || document.querySelector('.ls-progress');
        if (progressBar && progressBar.nextSibling) {
          progressBar.parentNode.insertBefore(this.previewEl, progressBar.nextSibling);
        } else if (progressBar) {
          progressBar.parentNode.appendChild(this.previewEl);
        } else {
          // Fallback: before the first step
          var relocated = document.querySelector('.ls-customizer-relocated');
          if (relocated) {
            relocated.prepend(this.previewEl);
          } else {
            return;
          }
        }

        this.previewEl.classList.add('ls-preview--mobile-inline');
        this._initSeePreviewFab();
        return;
      }

      var mediaCol = document.querySelector('.product-information__media');
      if (!mediaCol) return;

      this._gallery = mediaCol.querySelector('media-gallery');
      this._mediaCol = mediaCol;

      mediaCol.prepend(this.previewEl);
      this.previewEl.classList.add('ls-preview--relocated');
      this.previewEl.style.display = 'none';
    }

    /**
     * Floating "See Preview" button — mobile only.
     * Appears when a photo has been uploaded and the preview is scrolled out of view.
     */
    _initSeePreviewFab() {
      var self = this;
      var fab = document.createElement('button');
      fab.type = 'button';
      fab.className = 'ls-see-preview-fab';
      fab.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg> See Preview';
      fab.style.display = 'none';
      document.body.appendChild(fab);
      this._seePreviewFab = fab;

      fab.addEventListener('click', function () {
        self.previewEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });

      // Use IntersectionObserver to track preview visibility
      if ('IntersectionObserver' in window) {
        this._previewObserver = new IntersectionObserver(function (entries) {
          var isVisible = entries[0].isIntersecting;
          var hasPhoto = self.previewEl.classList.contains('has-photo');
          fab.style.display = (!isVisible && hasPhoto) ? '' : 'none';
        }, { threshold: 0.1 });
        this._previewObserver.observe(this.previewEl);
      }
    }

    _bindCloseButton() {
      var self = this;
      var closeBtn = qs('.ls-preview__close', this.previewEl);
      if (!closeBtn) return;

      closeBtn.addEventListener('click', function () {
        self._hidePreview();
      });
    }

    _showPreview() {
      this.previewEl.classList.add('has-photo');
      if (!this.previewEl.classList.contains('ls-preview--relocated')) {
        // On mobile (inline or original), show controls
        if (this.controlsEl) this.controlsEl.classList.add('is-visible');
        return;
      }
      this.previewEl.style.display = '';
      if (this._gallery) this._gallery.style.display = 'none';
      if (this.controlsEl) this.controlsEl.classList.add('is-visible');
      // Remove return button if it exists
      if (this._returnBtn) {
        this._returnBtn.remove();
        this._returnBtn = null;
      }
    }

    _hidePreview() {
      if (this.controlsEl) this.controlsEl.classList.remove('is-visible');
      if (!this.previewEl.classList.contains('ls-preview--relocated')) return;
      this.previewEl.style.display = 'none';
      if (this._gallery) {
        this._gallery.style.display = '';
        // Show "Back to Preview" button on top of gallery if a photo has been uploaded
        if (this.photoImage || this.backPhotoImage) {
          this._showReturnButton();
        }
      }
    }

    _showReturnButton() {
      if (this._returnBtn) return; // already exists
      var self = this;
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ls-preview__return';
      btn.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 12H3m0 0l4-4m-4 4l4 4"/><path d="M9 21h9a3 3 0 003-3V6a3 3 0 00-3-3H9"/></svg> Back to Preview';
      btn.addEventListener('click', function () {
        self._showPreview();
        if (self._returnBtn) {
          self._returnBtn.remove();
          self._returnBtn = null;
        }
      });
      this._mediaCol.insertBefore(btn, this._gallery);
      this._returnBtn = btn;
    }

    /** Get the active canvas (front, back for coins, or mirror index) */
    _getActiveCanvas() {
      if (this._activeFace === 'back' && this.backCanvas) return this.backCanvas;
      if (typeof this._activeMirror === 'number' && this._mirrors[this._activeMirror]) {
        return this._mirrors[this._activeMirror].fabricCanvas;
      }
      return this.canvas;
    }

    /** Get the active photo image */
    _getActivePhoto() {
      if (this._activeFace === 'back') return this.backPhotoImage;
      if (typeof this._activeMirror === 'number') {
        return this._mirrorPhotos[this._activeMirror] || null;
      }
      return this.photoImage;
    }

    _setActivePhoto(img) {
      if (this._activeFace === 'back') {
        this.backPhotoImage = img;
      } else if (typeof this._activeMirror === 'number') {
        this._mirrorPhotos[this._activeMirror] = img;
      } else {
        this.photoImage = img;
      }
    }

    /** Set a mirror (or main canvas) as the active target for controls */
    _setActiveMirror(idx) {
      // idx = null for main canvas, 0+ for mirror index
      this._activeMirror = idx;
      // Visual feedback: highlight the active frame
      var allFrames = qsa('.ls-preview__frame', this.previewEl);
      allFrames.forEach(function (f) { f.classList.remove('ls-preview__frame--active'); });
      if (idx === null || idx === undefined) {
        var mainFrame = qs('.ls-preview__frame:not(.ls-preview__mirror)', this.previewEl);
        if (mainFrame) mainFrame.classList.add('ls-preview__frame--active');
      } else if (this._mirrors[idx]) {
        this._mirrors[idx].wrapper.classList.add('ls-preview__frame--active');
      }
    }

    /** Create a clip path for the photo based on preview type */
    _createClipPath(canvas) {
      var w = canvas.width;
      var h = canvas.height;
      var cfg = this.config;

      if (cfg.clipShape === 'circle' && cfg.clipRadius) {
        var r = Math.min(w, h) * cfg.clipRadius;
        return new fabric.Circle({
          radius: r,
          left: w / 2 - r,
          top: h / 2 - r,
          absolutePositioned: true
        });
      }

      if (cfg.border) {
        var bw = cfg.border.width;
        return new fabric.Rect({
          left: bw, top: bw,
          width: w - bw * 2,
          height: h - bw * 2,
          absolutePositioned: true
        });
      }

      if (cfg.photoWindow) {
        var pw = cfg.photoWindow;
        return new fabric.Rect({
          left: w * pw.left,
          top: h * pw.top,
          width: w * pw.width,
          height: h * pw.height,
          rx: 6, ry: 6,
          absolutePositioned: true
        });
      }

      // clipShape: 'fromVar' — read the current CSS --ls-shape and determine clip
      // Skip for product-bg types (preview is always rectangular, shape is decorative only)
      if (cfg.productBg) return null;
      // Default to full canvas if no shape set
      var shapeVal = getComputedStyle(this.previewEl).getPropertyValue('--ls-shape').trim();
      if (shapeVal && shapeVal !== 'none') {
        return this._clipFromCssShape(shapeVal, w, h);
      }

      return null;
    }

    /** Parse CSS clip-path shape into a fabric.js clip path */
    _clipFromCssShape(shapeVal, w, h) {
      // circle(R%)
      var circleMatch = shapeVal.match(/circle\((\d+)%?\)/);
      if (circleMatch) {
        var pct = parseFloat(circleMatch[1]) / 100;
        var r = Math.min(w, h) * pct;
        return new fabric.Circle({
          radius: r,
          left: w / 2 - r,
          top: h / 2 - r,
          absolutePositioned: true
        });
      }

      // ellipse(Rx% Ry%)
      var ellipseMatch = shapeVal.match(/ellipse\((\d+)%\s+(\d+)%\)/);
      if (ellipseMatch) {
        var rx = w * parseFloat(ellipseMatch[1]) / 100;
        var ry = h * parseFloat(ellipseMatch[2]) / 100;
        return new fabric.Ellipse({
          rx: rx, ry: ry,
          left: w / 2 - rx,
          top: h / 2 - ry,
          absolutePositioned: true
        });
      }

      // inset(V round Rpx) — treat as rect
      var insetMatch = shapeVal.match(/inset\((\d+)/);
      if (insetMatch) {
        var insetVal = parseFloat(insetMatch[1]);
        return new fabric.Rect({
          left: insetVal, top: insetVal,
          width: w - insetVal * 2,
          height: h - insetVal * 2,
          rx: 4, ry: 4,
          absolutePositioned: true
        });
      }

      // polygon(...) — parse as SVG path-like points
      var polyMatch = shapeVal.match(/polygon\((.+)\)/);
      if (polyMatch) {
        var pointStr = polyMatch[1];
        var points = pointStr.split(',').map(function (pair) {
          var parts = pair.trim().split(/\s+/);
          return {
            x: parseFloat(parts[0]) / 100 * w,
            y: parseFloat(parts[1]) / 100 * h
          };
        });
        return new fabric.Polygon(points, {
          absolutePositioned: true
        });
      }

      // path(...) — heart shape etc., parse SVG path and scale to canvas
      var pathMatch = shapeVal.match(/path\(['"](.+?)['"]\)/);
      if (pathMatch) {
        try {
          var pathData = pathMatch[1];
          var pathObj = new fabric.Path(pathData, {
            absolutePositioned: true
          });
          // The path coords are 0-100; scale to canvas dimensions
          pathObj.set({
            scaleX: w / 100,
            scaleY: h / 100,
            left: 0,
            top: 0
          });
          return pathObj;
        } catch (e) {
          // Fallback to rect if path parsing fails
          return new fabric.Rect({
            left: w * 0.05, top: w * 0.05,
            width: w * 0.9, height: h * 0.9,
            absolutePositioned: true
          });
        }
      }

      return null;
    }

    /** Listen for file input changes and render photo on canvas */
    _bindPhotoUploads() {
      var self = this;
      var relocated = document.querySelector('.ls-customizer-relocated');
      var fileInputs = qsa('input[type="file"]', this.root);
      if (relocated) {
        fileInputs = fileInputs.concat(qsa('input[type="file"]', relocated));
      }

      fileInputs.forEach(function (input) {
        input.addEventListener('change', function () {
          var file = input.files[0];
          if (!file || !file.type.startsWith('image/')) return;

          var propName = (input.name || '').replace('properties[', '').replace(']', '');
          var isBack = propName.toLowerCase().indexOf('back') !== -1;

          // Multi-photo products: "Photo 1" → area 0 (main), "Photo 2" → area 1 (mirror 0), etc.
          var isMultiPhoto = self.config.multiPhoto;
          var photoIndex = 0; // default: main canvas
          if (isMultiPhoto) {
            var numMatch = propName.match(/Photo\s*(\d+)/i);
            if (numMatch) {
              photoIndex = parseInt(numMatch[1], 10) - 1; // 0-indexed
            }
          }

          // Set active face for coins
          if (self.type === 'coin' && isBack) {
            self._activeFace = 'back';
          } else {
            self._activeFace = 'front';
          }

          var reader = new FileReader();
          reader.onload = function (e) {
            var dataUrl = e.target.result;

            dbg('Photo upload —', 'prop:', propName, 'isMultiPhoto:', isMultiPhoto, 'photoIndex:', photoIndex, 'isBack:', isBack);
            dbg('  mirrors available:', self._mirrors.length, 'mirror objects:', self._mirrors.map(function(m,i){ return 'mirror['+i+']: wrapper='+(m.wrapper?'yes':'NO')+' fabricCanvas='+(m.fabricCanvas?'yes':'NO')+' display='+m.wrapper.style.display; }));

            if (isMultiPhoto && photoIndex > 0) {
              var mirrorIdx = photoIndex - 1;
              var mirror = self._mirrors[mirrorIdx];
              dbg('  → MIRROR path — mirrorIdx:', mirrorIdx, 'mirror exists:', !!mirror);
              if (mirror) {
                mirror.wrapper.style.display = '';
                if (!self._mirrorDataUrls) self._mirrorDataUrls = [];
                self._mirrorDataUrls[mirrorIdx] = dataUrl;

                var wrapperW = mirror.wrapper.clientWidth;
                var wrapperH = mirror.wrapper.clientHeight;
                var container = mirror.wrapper.parentElement;
                var containerW = container ? container.clientWidth : 0;
                var containerH = container ? container.clientHeight : 0;
                dbg('  wrapper dims:', wrapperW + 'x' + wrapperH, 'container dims:', containerW + 'x' + containerH, 'wrapper style.width:', mirror.wrapper.style.width, 'style.height:', mirror.wrapper.style.height);

                (function (idx, m, url) {
                  requestAnimationFrame(function () {
                    dbg('  [rAF] mirror[' + idx + '] — wrapper.clientWidth:', m.wrapper.clientWidth, 'clientHeight:', m.wrapper.clientHeight);
                    var retries = 0;
                    (function tryAdd() {
                      if (!m.fabricCanvas) {
                        dbg('  [tryAdd] mirror[' + idx + '] — initSingleMirror attempt #' + retries);
                        self._initSingleMirror(m);
                      }
                      if (!m.fabricCanvas) {
                        if (retries++ < 60) { setTimeout(tryAdd, retries < 10 ? 50 : 150); return; }
                        dbg('  [tryAdd] mirror[' + idx + '] — GAVE UP after 60 retries');
                        return;
                      }
                      dbg('  [tryAdd] mirror[' + idx + '] — canvas ready, dims:', m.fabricCanvas.width + 'x' + m.fabricCanvas.height, '— adding photo');
                      if (self._mirrorPhotos[idx]) {
                        m.fabricCanvas.remove(self._mirrorPhotos[idx]);
                      }
                      self._addPhotoToMirror(idx, m, url);
                    })();
                  });
                })(mirrorIdx, mirror, dataUrl);
              } else {
                dbg('  → mirror[' + mirrorIdx + '] NOT FOUND in _mirrors array!');
              }
            } else {
              dbg('  → MAIN canvas path');
              self._addPhotoToCanvas(dataUrl);
              if (!isMultiPhoto && !isBack) self._updateMirrors(dataUrl);
            }

            self.previewEl.classList.add('has-photo');
          };
          reader.readAsDataURL(file);
        });

        // Handle file removal
        var uploadEl = input.closest('.ls-file-upload');
        if (uploadEl) {
          var removeBtn = qs('.ls-file-upload__remove', uploadEl);
          if (removeBtn) {
            removeBtn.addEventListener('click', function () {
              var propName = (input.name || '').replace('properties[', '').replace(']', '');
              var isBack = propName.toLowerCase().indexOf('back') !== -1;

              if (self.config.multiPhoto) {
                var numMatch = propName.match(/Photo\s*(\d+)/i);
                var photoIndex = numMatch ? parseInt(numMatch[1], 10) - 1 : 0;
                if (photoIndex > 0) {
                  var mirrorIdx = photoIndex - 1;
                  var mirror = self._mirrors[mirrorIdx];
                  if (mirror && mirror.fabricCanvas && self._mirrorPhotos[mirrorIdx]) {
                    mirror.fabricCanvas.remove(self._mirrorPhotos[mirrorIdx]);
                    self._mirrorPhotos[mirrorIdx] = null;
                    mirror.wrapper.style.display = 'none';
                    mirror.fabricCanvas.renderAll();
                  }
                  if (self._mirrorDataUrls) self._mirrorDataUrls[mirrorIdx] = null;
                  return;
                }
              }

              self._removePhoto(isBack ? 'back' : 'front');
            });
          }
        }
      });
    }

    /** Add a photo image to the active canvas */
    _addPhotoToCanvas(dataUrl) {
      var self = this;
      var canvas = this._getActiveCanvas();
      if (!canvas) return;

      // Remove existing photo if any
      var existing = this._getActivePhoto();
      if (existing) {
        canvas.remove(existing);
      }

      fabric.FabricImage.fromURL(dataUrl).then(function (img) {
        // If canvas has zero dimensions (bg image wasn't loaded yet), resize now
        if (canvas.width < 10 || canvas.height < 10) {
          var frameEl = canvas.lowerCanvasEl.closest('.ls-preview__frame');
          if (frameEl) {
            var fw = frameEl.clientWidth || 320;
            var fh = self.config.productBg ? (frameEl.clientHeight || fw) : Math.round(fw / (self.config.aspect || 1));
            canvas.setDimensions({ width: fw, height: fh });
          }
        }
        var w = canvas.width;
        var h = canvas.height;
        var cfg = self.config;

        // Calculate the photo window region
        var targetW, targetH, targetLeft, targetTop;
        if (cfg.photoWindow) {
          targetW = w * cfg.photoWindow.width;
          targetH = h * cfg.photoWindow.height;
          targetLeft = w * cfg.photoWindow.left;
          targetTop = h * cfg.photoWindow.top;
        } else if (cfg.border) {
          var bw = cfg.border.width;
          targetW = w - bw * 2;
          targetH = h - bw * 2;
          targetLeft = bw;
          targetTop = bw;
        } else {
          targetW = w;
          targetH = h;
          targetLeft = 0;
          targetTop = 0;
        }

        // splitPhoto: crop the image into N vertical slices (main canvas = slice 0)
        var splits = cfg.splitPhoto || 0;
        if (splits > 1) {
          var sliceW = Math.floor(img.width / splits);
          img.set({
            cropX: 0,
            cropY: 0,
            width: sliceW,
            height: img.height
          });
        }

        // Scale to cover the target region
        var scaleX = targetW / img.width;
        var scaleY = targetH / img.height;
        var scale = Math.max(scaleX, scaleY);

        img.set({
          scaleX: scale,
          scaleY: scale,
          left: targetLeft + targetW / 2,
          top: targetTop + targetH / 2,
          originX: 'center',
          originY: 'center',
          selectable: true,
          hasControls: true,
          hasBorders: true,
          lockUniScaling: true,
          cornerSize: 20,
          touchCornerSize: 44,
          cornerColor: '#c8a45d',
          cornerStrokeColor: '#fff',
          cornerStyle: 'circle',
          borderColor: '#c8a45d',
          transparentCorners: false,
          padding: 0
        });

        // Products with lockPhoto show the photo exactly as placed and give the
        // customer no way to move it. On the three-panel canvas one photo is
        // split across three canvases, so any hand positioning has to be applied
        // to all three to stay aligned — simpler to fix the placement than to
        // offer a control that only makes sense when it is mirrored.
        // evented:false also stops the panel picking up click/selection events,
        // so no selection handles ever appear.
        if (self.config.lockPhoto) {
          img.set({
            selectable: false,
            evented: false,
            hasControls: false,
            hasBorders: false,
            lockMovementX: true,
            lockMovementY: true,
            lockScalingX: true,
            lockScalingY: true,
            lockRotation: true
          });
        }

        // Apply clip path
        var clipPath = self._createClipPath(canvas);
        if (clipPath) {
          img.clipPath = clipPath;
        }

        canvas.add(img);

        // Ensure decorations stay in correct z-order
        if (canvas._lsBorderRect) canvas.bringObjectToFront(canvas._lsBorderRect);
        if (canvas._lsVinylHole) canvas.bringObjectToFront(canvas._lsVinylHole);

        canvas.setActiveObject(img);
        canvas.renderAll();

        self._setActivePhoto(img);
        self._showPreview();
        self._updateTextOverlay();

        // Force a second render after a short delay — some browsers don't
        // paint the canvas until the next animation frame or after layout
        setTimeout(function () { canvas.renderAll(); }, 100);

        // Ensure canvas dimensions match frame — retry until frame has layout
        var retries = 0;
        function fixCanvasSize() {
          var frameEl = canvas.lowerCanvasEl.closest('.ls-preview__frame');
          if (!frameEl) return;
          var fw = frameEl.clientWidth;
          var fh = self.config.productBg ? frameEl.clientHeight : Math.round(fw / (self.config.aspect || 1));
          if (!fw || !fh) {
            // Frame still has no dimensions — retry
            if (++retries < 20) setTimeout(fixCanvasSize, 150);
            return;
          }
          if (fw !== canvas.width || fh !== canvas.height) {
            canvas.setDimensions({ width: fw, height: fh });
            // Recalculate photo position using same logic as initial placement
            var tw, th, tl, tt;
            if (cfg.photoWindow) {
              tw = fw * cfg.photoWindow.width;
              th = fh * cfg.photoWindow.height;
              tl = fw * cfg.photoWindow.left;
              tt = fh * cfg.photoWindow.top;
            } else if (cfg.border) {
              var bw2 = cfg.border.width;
              tw = fw - bw2 * 2;
              th = fh - bw2 * 2;
              tl = bw2;
              tt = bw2;
            } else {
              tw = fw; th = fh; tl = 0; tt = 0;
            }
            var sx = tw / img.width;
            var sy = th / img.height;
            var s = Math.max(sx, sy);
            img.set({ scaleX: s, scaleY: s, left: tl + tw / 2, top: tt + th / 2 });
            if (img.clipPath) {
              img.clipPath = self._createClipPath(canvas);
            }
            // self._resizeCoinRim(canvas, fw); // COMMENTED OUT: coin images now include the rim
          }
          canvas.renderAll();
        }
        requestAnimationFrame(fixCanvasSize);
      });
    }

    /** Remove photo from a specific face */
    _removePhoto(face) {
      var canvas = face === 'back' ? this.backCanvas : this.canvas;
      var photo = face === 'back' ? this.backPhotoImage : this.photoImage;

      if (canvas && photo) {
        canvas.remove(photo);
        canvas.renderAll();
      }

      if (face === 'back') {
        this.backPhotoImage = null;
      } else {
        this.photoImage = null;
        this._clearMirrors();
      }

      // If no photos remain on any canvas, hide preview
      if (!this.photoImage && !this.backPhotoImage) {
        this.previewEl.classList.remove('has-photo');
        this._hidePreview();
        // Hide text overlay and reset drag position when no photo
        if (this._textOverlayEl) {
          this._textOverlayEl.classList.remove('is-visible');
          if (this._textOverlayEl._lsResetDrag) this._textOverlayEl._lsResetDrag();
        }
        if (this._plaqueTextAreaEl) this._plaqueTextAreaEl.innerHTML = '';
      }
    }

    /** Bind mobile control buttons */
    _bindControls() {
      var self = this;
      if (!this.controlsEl) return;

      var ctrls = qsa('.ls-preview__ctrl', this.controlsEl);
      ctrls.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var action = btn.dataset.action;
          var canvas = self._getActiveCanvas();
          var photo = self._getActivePhoto();
          if (!canvas || !photo) return;

          var MOVE_PX = 5;
          var SCALE_STEP = 0.1;
          var ROTATE_DEG = 15;

          switch (action) {
            case 'up':
              photo.set('top', photo.top - MOVE_PX);
              break;
            case 'down':
              photo.set('top', photo.top + MOVE_PX);
              break;
            case 'left':
              photo.set('left', photo.left - MOVE_PX);
              break;
            case 'right':
              photo.set('left', photo.left + MOVE_PX);
              break;
            case 'zoom-in':
              photo.set('scaleX', photo.scaleX * (1 + SCALE_STEP));
              photo.set('scaleY', photo.scaleY * (1 + SCALE_STEP));
              break;
            case 'zoom-out':
              photo.set('scaleX', photo.scaleX * (1 - SCALE_STEP));
              photo.set('scaleY', photo.scaleY * (1 - SCALE_STEP));
              break;
            case 'rotate':
              photo.set('angle', (photo.angle + ROTATE_DEG) % 360);
              break;
            case 'fit':
              // Re-fit the photo to cover the canvas (same logic as initial placement)
              var cw = canvas.width;
              var ch = canvas.height;
              var fitScaleX = cw / (photo.width || 1);
              var fitScaleY = ch / (photo.height || 1);
              var fitScale = Math.max(fitScaleX, fitScaleY);
              photo.set({
                scaleX: fitScale,
                scaleY: fitScale,
                left: cw / 2,
                top: ch / 2,
                originX: 'center',
                originY: 'center',
                angle: 0
              });
              break;
            case 'replace':
              // Trigger the file input for the active photo slot
              var relocated = document.querySelector('.ls-customizer-relocated');
              var searchRoot = relocated || self.root;
              var fileInputs = qsa('input[type="file"]', searchRoot);
              if (fileInputs.length > 0) {
                var targetInput = fileInputs[0];
                if (self._activeFace === 'back' && fileInputs.length > 1) {
                  // Coins: back face → last file input
                  targetInput = fileInputs[fileInputs.length - 1];
                } else if (typeof self._activeMirror === 'number') {
                  // Multi-photo: mirror index N → file input N+1 (0 = main photo)
                  var inputIdx = self._activeMirror + 1;
                  if (inputIdx < fileInputs.length) {
                    targetInput = fileInputs[inputIdx];
                  }
                }
                targetInput.click();
              }
              return;
          }

          photo.setCoords();
          canvas.renderAll();

          // Split-photo products (the three-panel canvas) show ONE photo sliced
          // across several canvases, so a nudge or zoom is only correct if every
          // panel moves with it. _bindSplitSync() already mirrors mouse dragging,
          // but it listens for fabric's object:moving / object:scaling events and
          // these buttons set properties directly, so nothing fired and only the
          // panel that happened to be active moved.
          self._syncSplitPanels();
        });
      });
    }

    /** Listen for radio/select/color changes and update CSS + canvas */
    _bindOptionChanges() {
      var self = this;
      var relocated = document.querySelector('.ls-customizer-relocated');
      var inputs = qsa('input[type="radio"], select', this.root);
      if (relocated) {
        inputs = inputs.concat(qsa('input[type="radio"], select', relocated));
      }
      inputs.forEach(function (input) {
        input.addEventListener('change', function () {
          self._handleOptionChange(input);
        });
      });
    }

    _handleOptionChange(input) {
      var propName = (input.name || '').replace('properties[', '').replace(']', '');
      var value = input.value;

      var mapping = PROPERTY_TO_CSS[propName];
      if (!mapping) return;

      var cssValue;
      if (mapping.map && OPTION_MAPS[mapping.map]) {
        var mapObj = OPTION_MAPS[mapping.map];
        cssValue = mapObj[value];
        // Fuzzy match: if exact key fails, check if value contains a map key
        // e.g. '5½" Heart' matches 'Heart', '4" Round' matches 'Round'
        if (!cssValue) {
          var keys = Object.keys(mapObj);
          for (var ki = 0; ki < keys.length; ki++) {
            if (value.indexOf(keys[ki]) !== -1) {
              cssValue = mapObj[keys[ki]];
              break;
            }
          }
        }
      } else {
        cssValue = value;
      }

      if (cssValue) {
        this.previewEl.style.setProperty(mapping.prop, cssValue);
      }

      // Update canvas border color if applicable
      if (this.canvas && this.canvas._lsBorderRect && this.config.border) {
        var newColor = this.config.border.colorFixed
          || getComputedStyle(this.previewEl).getPropertyValue(this.config.border.colorVar).trim();
        if (newColor) {
          this.canvas._lsBorderRect.set('stroke', newColor);
          this.canvas.renderAll();
        }
      }

      /* --- COMMENTED OUT: coin images now include the rim border ---
      // Update coin rim gradient (both front and back)
      if (propName === 'Finish') {
        var stops = value === 'Silver' ? LsPreview.COIN_SILVER_STOPS : LsPreview.COIN_GOLD_STOPS;
        var strokeColor = value === 'Silver' ? '#5A5A5A' : '#6B5418';
        var coinCanvases = [this.canvas, this.backCanvas];
        for (var ci = 0; ci < coinCanvases.length; ci++) {
          var cc = coinCanvases[ci];
          if (cc && cc._lsCoinRim) {
            var rr = cc.width / 2;
            var grad = new fabric.Gradient({
              type: 'radial',
              coords: { x1: rr, y1: rr, r1: rr * 0.65, x2: rr, y2: rr, r2: rr },
              colorStops: stops
            });
            cc._lsCoinRim.set({ fill: grad, stroke: strokeColor });
            cc.renderAll();
          }
        }
      }
      --- END COMMENTED OUT */

      // Update clip path when shape changes
      if (mapping.prop === '--ls-shape' && this.canvas) {
        var photo = this.photoImage;
        if (photo) {
          // Delay slightly so CSS var is updated
          var self = this;
          setTimeout(function () {
            var clip = self._createClipPath(self.canvas);
            if (clip) {
              photo.clipPath = clip;
              self.canvas.renderAll();
            }
          }, 50);
        }
      }

      // Base element removed — product-bg images include the stand
    }

    /** Coin text overlay — listen for text inputs and update SVG text */
    _bindCoinTextInputs() {
      if (this.type !== 'coin') return;
      var self = this;

      // SVG text elements for front and back faces
      var frontSvg = qs('.ls-preview__coin-text[data-face="front"]', this.previewEl);
      var backSvg = qs('.ls-preview__coin-text[data-face="back"]', this.previewEl);
      if (!frontSvg) return;

      // Draggable center text divs (HTML, not SVG)
      var frontCenter = qs('.ls-coin-center-text[data-face="front"]', this.previewEl);
      var backCenter = qs('.ls-coin-center-text[data-face="back"]', this.previewEl);

      this._coinTextEls = {
        front: {
          top: qs('.ls-coin-text__top', frontSvg),
          bottom: qs('.ls-coin-text__bottom', frontSvg),
          center: frontCenter
        },
        back: backSvg ? {
          top: qs('.ls-coin-text__top', backSvg),
          bottom: qs('.ls-coin-text__bottom', backSvg),
          center: backCenter
        } : null
      };

      // Make center text divs draggable
      if (frontCenter) this._makeDraggable(frontCenter);
      if (backCenter) this._makeDraggable(backCenter);

      // Mapping: property name → { face, position }
      // Varies by coin type, so we listen to all text/textarea inputs and map dynamically
      var searchRoot = document.querySelector('.ls-customizer-relocated') || this.root;

      // Use MutationObserver to catch conditionally revealed inputs.
      // Selects are included so dropdown-driven coins render in the preview --
      // the Temple Commemorative coin's only customer input is the temple
      // dropdown, so without this its preview stays blank.
      var bindInputs = function () {
        var textInputs = qsa('input[type="text"], textarea, select', searchRoot);
        textInputs.forEach(function (input) {
          if (input._lsCoinBound) return;
          input._lsCoinBound = true;
          input.addEventListener('input', function () {
            self._updateCoinText();
          });
          input.addEventListener('change', function () {
            self._updateCoinText();
          });
        });
      };

      // Bind existing inputs
      bindInputs();

      // Re-bind when conditional steps are revealed
      var observer = new MutationObserver(function () {
        bindInputs();
      });
      observer.observe(searchRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });

      // Refresh text and toggle whenever any selection inside the customizer
      // changes. This used to enumerate conditional groups by hand
      // ('[data-coin-type], [data-temple-mode], [data-sports-mode]'), which went
      // stale as soon as the coin branches changed -- temple-mode and sports-mode
      // no longer exist and cruise-design was never in the list. A single
      // delegated listener covers every current and future branch.
      searchRoot.addEventListener('change', function () {
        setTimeout(function () {
          self._updateCoinText();
          self._updateCoinToggle();
        }, 100);
      });

      // Initial check
      setTimeout(function () { self._updateCoinToggle(); }, 200);
    }

    /** Read all visible text inputs and map them to coin SVG text positions */
    _updateCoinText() {
      if (!this._coinTextEls) return;

      var searchRoot = document.querySelector('.ls-customizer-relocated') || this.root;

      // Collect all visible text inputs with their property names and values.
      // Selects included -- see _bindCoinTextInputs.
      var textInputs = qsa('input[type="text"], textarea, select', searchRoot);
      var fields = [];
      textInputs.forEach(function (input) {
        // Skip inputs inside inactive conditional blocks
        var cond = input.closest('.ls-conditional');
        if (cond && !cond.classList.contains('is-active')) return;
        // Also check parent conditionals (nested conditionals like temple → personalized)
        var parentCond = cond ? cond.parentElement.closest('.ls-conditional') : null;
        if (parentCond && !parentCond.classList.contains('is-active')) return;

        var name = (input.name || '').replace('properties[', '').replace(']', '');
        // Same exclusions as the non-coin text overlay: these are instructions or
        // packing-slip copy, not text that gets struck into the coin.
        var nameLower = name.toLowerCase();
        if (nameLower.indexOf('gift message') !== -1) return;
        if (nameLower.indexOf('silhouette notes') !== -1) return;
        if (nameLower.indexOf('photo description') !== -1) return;
        if (name && input.value.trim()) {
          fields.push({ name: nameLower, value: input.value.trim() });
        }
      });

      // Determine which fields go where based on naming patterns
      var front = this._coinTextEls.front;
      var back = this._coinTextEls.back;

      // Reset all text
      if (front.top) front.top.textContent = '';
      if (front.bottom) front.bottom.textContent = '';
      if (front.center) front.center.textContent = '';
      if (back) {
        if (back.top) back.top.textContent = '';
        if (back.bottom) back.bottom.textContent = '';
        if (back.center) back.center.textContent = '';
      }

      // Map fields to positions based on property name patterns
      var frontTexts = [];
      var backTexts = [];

      fields.forEach(function (f) {
        var n = f.name;
        if (n.indexOf('back') !== -1) {
          backTexts.push(f.value);
        } else {
          frontTexts.push(f.value);
        }
      });

      // Front face: first → top arc (rim), last → bottom arc (rim), middle → center (on photo)
      if (frontTexts.length === 1) {
        if (front.top) front.top.textContent = frontTexts[0];
      } else if (frontTexts.length === 2) {
        if (front.top) front.top.textContent = frontTexts[0];
        if (front.bottom) front.bottom.textContent = frontTexts[1];
      } else if (frontTexts.length >= 3) {
        if (front.top) front.top.textContent = frontTexts[0];
        if (front.bottom) front.bottom.textContent = frontTexts[frontTexts.length - 1];
        if (front.center) front.center.textContent = frontTexts.slice(1, -1).join(' · ');
      }

      // Back face: same layout
      if (back) {
        if (backTexts.length === 1) {
          if (back.top) back.top.textContent = backTexts[0];
        } else if (backTexts.length === 2) {
          if (back.top) back.top.textContent = backTexts[0];
          if (back.bottom) back.bottom.textContent = backTexts[1];
        } else if (backTexts.length >= 3) {
          if (back.top) back.top.textContent = backTexts[0];
          if (back.bottom) back.bottom.textContent = backTexts[backTexts.length - 1];
          if (back.center) back.center.textContent = backTexts.slice(1, -1).join(' · ');
        }
      }
    }

    /** Text overlay for product-bg types (non-coin) — shows text on top of canvas */
    _bindTextOverlay() {
      if (this.type === 'coin') return;

      var productBgEl = qs('.ls-preview__product-bg', this.previewEl);
      if (!productBgEl) return;

      this._textOverlayEl = qs('.ls-preview__text-overlay', productBgEl);
      if (!this._textOverlayEl) return;

      // Position text overlay at the bottom-center of the frame area
      var frameEl = qs('.ls-preview__frame', productBgEl);
      if (frameEl) {
        // Place overlay within frame bounds — starts at bottom center
        var areas = this.config.photoAreas;
        var a = areas && areas[0] ? areas[0] : null;
        if (a) {
          this._textOverlayEl.style.left = (a.left + a.width / 2) + '%';
          this._textOverlayEl.style.bottom = (100 - a.top - a.height + 4) + '%';
          this._textOverlayEl.style.transform = 'translateX(-50%)';
        }
      }

      // Make text overlay draggable
      this._makeOverlayDraggable(this._textOverlayEl);

      var self = this;
      var searchRoot = document.querySelector('.ls-customizer-relocated') || this.root;

      // Property names that are instructions, not display text
      // 'gift message' is packing-slip copy, not artwork — it must never be
      // drawn onto the product preview.
      //
      // These are matched against the INPUT NAME, which for the text-fields step
      // type comes from the field LABEL, not from the `property:` argument. That
      // is why 'silhouette' is matched and not 'silhouette notes': the shadow box
      // passes property: 'Silhouette Notes' but labels the field "Which part of
      // your photo should be the front silhouette?", so the input is really
      // properties[Which part of your photo should be the front silhouette?].
      // The old 'silhouette notes' string could never match it, and the answer
      // leaked onto the preview alongside the Add Your Text lines.
      // 'gift message' works only because that field's label happens to equal its
      // property name — so keep these entries matched to labels, not properties.
      // 'cutout' covers the light box, where the same field was renamed from
      // "...front silhouette?" to "...front Full-Color Photo Cutout?" — matching
      // only on 'silhouette' would have stopped excluding it.
      var excludeProps = ['silhouette', 'cutout', 'photo description', 'gift message', '_preview'];

      this._textOverlayExclude = excludeProps;

      var bindInputs = function () {
        var textInputs = qsa('input[type="text"], textarea', searchRoot);
        textInputs.forEach(function (input) {
          if (input._lsOverlayBound) return;
          input._lsOverlayBound = true;
          input.addEventListener('input', function () {
            self._updateTextOverlay();
          });
        });
        // Also listen for font selection changes
        var fontRadios = qsa('input[type="radio"]', searchRoot);
        fontRadios.forEach(function (radio) {
          if (radio._lsOverlayFontBound) return;
          var propName = (radio.name || '').replace('properties[', '').replace(']', '').toLowerCase();
          if (propName.indexOf('font') === -1) return;
          radio._lsOverlayFontBound = true;
          radio.addEventListener('change', function () {
            self._updateTextOverlay();
          });
        });
      };

      bindInputs();

      // Re-bind when conditional steps are revealed
      var observer = new MutationObserver(function () {
        bindInputs();
        self._updateTextOverlay();
      });
      observer.observe(searchRoot, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });
    }

    /** Read visible text inputs and render them in the overlay */
    _updateTextOverlay() {
      if (!this._textOverlayEl) return;

      // Default overlay requires a photo; plaque text area is always visible
      if (!this.photoImage && !this._plaqueTextAreaEl) {
        this._textOverlayEl.classList.remove('is-visible');
        return;
      }

      var searchRoot = document.querySelector('.ls-customizer-relocated') || this.root;
      var textInputs = qsa('input[type="text"], textarea', searchRoot);
      var excludeProps = this._textOverlayExclude || [];
      var lines = [];
      var fontFamily = '';

      // Find selected font
      var fontRadios = qsa('input[type="radio"]:checked', searchRoot);
      for (var fi = 0; fi < fontRadios.length; fi++) {
        var fpn = (fontRadios[fi].name || '').replace('properties[', '').replace(']', '').toLowerCase();
        if (fpn.indexOf('font') !== -1) {
          fontFamily = fontRadios[fi].value;
          break;
        }
      }

      textInputs.forEach(function (input) {
        // Skip inputs inside inactive conditional blocks
        var cond = input.closest('.ls-conditional');
        if (cond && !cond.classList.contains('is-active')) return;
        var parentCond = cond ? cond.parentElement.closest('.ls-conditional') : null;
        if (parentCond && !parentCond.classList.contains('is-active')) return;

        var name = (input.name || '').replace('properties[', '').replace(']', '');
        var nameLower = name.toLowerCase();

        // Skip excluded properties
        for (var ei = 0; ei < excludeProps.length; ei++) {
          if (nameLower.indexOf(excludeProps[ei]) !== -1) return;
        }

        var val = input.value.trim();
        if (val) {
          lines.push(val);
        }
      });

      // When a dedicated plaque text area exists (e.g. Style 5 row 2 middle),
      // render text there and hide the default floating overlay
      if (this._plaqueTextAreaEl) {
        this._plaqueTextAreaEl.innerHTML = '';
        if (lines.length > 0) {
          for (var pi = 0; pi < lines.length; pi++) {
            var ptDiv = document.createElement('div');
            ptDiv.className = 'ls-preview__plaque-text-line';
            ptDiv.textContent = lines[pi];
            if (fontFamily) {
              ptDiv.style.fontFamily = '"' + fontFamily + '", sans-serif';
            }
            this._plaqueTextAreaEl.appendChild(ptDiv);
          }
        }
        // Hide the default floating overlay when plaque text area is active
        this._textOverlayEl.classList.remove('is-visible');
        this._textOverlayEl.innerHTML = '';
        return;
      }

      // Render lines in the default floating overlay
      this._textOverlayEl.innerHTML = '';
      if (lines.length === 0) {
        this._textOverlayEl.classList.remove('is-visible');
        return;
      }

      for (var li = 0; li < lines.length; li++) {
        var div = document.createElement('div');
        div.className = 'ls-preview__text-overlay__line';
        div.textContent = lines[li];
        if (fontFamily) {
          div.style.fontFamily = '"' + fontFamily + '", sans-serif';
        }
        this._textOverlayEl.appendChild(div);
      }
      this._textOverlayEl.classList.add('is-visible');
    }

    /** Make the text overlay draggable within the product-bg container */
    _makeOverlayDraggable(el) {
      var dragX = 0, dragY = 0;
      var startX, startY, startDX, startDY;

      function onStart(e) {
        e.preventDefault();
        e.stopPropagation();
        var point = e.touches ? e.touches[0] : e;
        startX = point.clientX;
        startY = point.clientY;
        startDX = dragX;
        startDY = dragY;
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onEnd);
        document.addEventListener('touchmove', onMove, { passive: false });
        document.addEventListener('touchend', onEnd);
      }

      function onMove(e) {
        e.preventDefault();
        var point = e.touches ? e.touches[0] : e;
        dragX = startDX + (point.clientX - startX);
        dragY = startDY + (point.clientY - startY);
        el.style.transform = 'translateX(-50%) translate(' + dragX + 'px, ' + dragY + 'px)';
      }

      function onEnd() {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onEnd);
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('touchend', onEnd);
      }

      el.addEventListener('mousedown', onStart);
      el.addEventListener('touchstart', onStart, { passive: false });

      // Store reset function so position can be cleared when photo is removed
      el._lsResetDrag = function () {
        dragX = 0;
        dragY = 0;
        el.style.transform = 'translateX(-50%)';
      };
    }

    /** Make an element draggable within the preview frame */
    _makeDraggable(el) {
      var offsetX = 0, offsetY = 0;
      var startX, startY, startOX, startOY;

      function onStart(e) {
        e.preventDefault();
        var point = e.touches ? e.touches[0] : e;
        startX = point.clientX;
        startY = point.clientY;
        startOX = offsetX;
        startOY = offsetY;
        document.addEventListener('mousemove', onMove);
        document.addEventListener('mouseup', onEnd);
        document.addEventListener('touchmove', onMove, { passive: false });
        document.addEventListener('touchend', onEnd);
      }

      function onMove(e) {
        e.preventDefault();
        var point = e.touches ? e.touches[0] : e;
        offsetX = startOX + (point.clientX - startX);
        offsetY = startOY + (point.clientY - startY);
        el.style.transform = 'translate(calc(-50% + ' + offsetX + 'px), calc(-50% + ' + offsetY + 'px))';
      }

      function onEnd() {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onEnd);
        document.removeEventListener('touchmove', onMove);
        document.removeEventListener('touchend', onEnd);
      }

      el.addEventListener('mousedown', onStart);
      el.addEventListener('touchstart', onStart, { passive: false });
    }

    /** Set initial coin frame positions based on the currently selected coin type */
    /* --- COMMENTED OUT: coin images now include the rim border ---
    _resizeCoinRim(canvas, size) {
      if (!canvas || !canvas._lsCoinRim) return;
      var rim = canvas._lsCoinRim;
      var r = size / 2;
      rim.set({ radius: r, left: 0, top: 0 });
      var oldStops = rim.fill && rim.fill.colorStops
        ? rim.fill.colorStops
        : LsPreview.COIN_GOLD_STOPS;
      rim.set('fill', new fabric.Gradient({
        type: 'radial',
        coords: { x1: r, y1: r, r1: r * 0.65, x2: r, y2: r, r2: r },
        colorStops: oldStops
      }));
    }
    --- END COMMENTED OUT */
    _resizeCoinRim() {} // no-op stub

    _initCoinFramePositions() {
      if (this.type !== 'coin') return;
      // Find which coin type radio is currently checked (browser may restore form state)
      var relocated = document.querySelector('.ls-customizer-relocated');
      var searchRoot = relocated || this.root;
      // Per-coin products (customizer_type 'coin-missionary' etc.) have no coin
      // type step, so there is no radio to read — the liquid stamps the coin type
      // on the customizer root instead. Without this the fallback below would
      // silently render EVERY coin product as the Missionary coin: wrong
      // background image and wrong front/back frame positions.
      var fixedCoinType = this.root && this.root.dataset ? this.root.dataset.coinType : '';
      var checked = qs('input[data-coin-type]:checked', searchRoot);
      var coinType = fixedCoinType || (checked ? checked.dataset.coinType : 'missionary');

      // Sync background image to match the checked type (browser may restore
      // a radio other than the default, but the <img> src is always the default)
      var coinBgEl = qs('.ls-preview__coin-bg', this.previewEl);
      if (coinBgEl) {
        var camelVal = coinType.charAt(0).toUpperCase() + coinType.slice(1).replace(/-([a-z])/g, function(_, c) { return c.toUpperCase(); });
        var newSrc = coinBgEl.dataset['coinBg' + camelVal];
        if (newSrc) {
          var imgEl = qs('.ls-preview__coin-bg-img', coinBgEl);
          if (imgEl) imgEl.src = newSrc;
        }
      }

      this._repositionCoinFrames(coinType);
    }

    /** Reposition coin front/back frames when coin type changes */
    _repositionCoinFrames(coinType) {
      var areas = this.config.coinAreas;
      if (!areas || !areas[coinType]) return;

      var pos = areas[coinType];
      var coinBgEl = qs('.ls-preview__coin-bg', this.previewEl);
      if (!coinBgEl) return;

      var frontFrame = qs('.ls-preview__frame--coin-front', coinBgEl);
      var backFrame = qs('.ls-preview__frame--coin-back', coinBgEl);

      if (frontFrame) {
        frontFrame.style.left   = pos.front.left + '%';
        frontFrame.style.top    = pos.front.top + '%';
        frontFrame.style.width  = pos.front.width + '%';
        frontFrame.style.right  = 'auto';
      }

      if (backFrame && pos.back) {
        backFrame.style.left   = pos.back.left + '%';
        backFrame.style.top    = pos.back.top + '%';
        backFrame.style.width  = pos.back.width + '%';
        backFrame.style.right  = 'auto';
        backFrame.style.display = '';
      } else if (backFrame) {
        backFrame.style.display = 'none';
      }

      // Reinitialize canvases to match new frame dimensions
      var self = this;
      setTimeout(function () {
        if (self.canvas) {
          var frontCanvasEl = qs('.ls-preview__canvas[data-face="front"]', self.previewEl);
          if (frontCanvasEl && frontFrame) {
            var fw = frontFrame.clientWidth || 200;
            self.canvas.setDimensions({ width: fw, height: fw });
            // self._resizeCoinRim(self.canvas, fw); // COMMENTED OUT: coin images now include the rim
            self.canvas.renderAll();
          }
        }
        if (self.backCanvas && backFrame && backFrame.style.display !== 'none') {
          var backCanvasEl = qs('.ls-preview__canvas[data-face="back"]', self.previewEl);
          if (backCanvasEl) {
            var bw = backFrame.clientWidth || 200;
            self.backCanvas.setDimensions({ width: bw, height: bw });
            // self._resizeCoinRim(self.backCanvas, bw); // COMMENTED OUT: coin images now include the rim
            self.backCanvas.renderAll();
          }
        }
      }, 100);
    }

    /** Coin toggle removed — front/back are side-by-side */
    _bindCoinToggle() {}
    _updateCoinToggle() {}
  }

  /* --- COMMENTED OUT: coin images now include the rim border ---
  LsPreview.COIN_GOLD_STOPS = [
    { offset: 0,    color: '#8B6914' },
    { offset: 0.10, color: '#D4A833' },
    { offset: 0.25, color: '#F0D060' },
    { offset: 0.40, color: '#C49520' },
    { offset: 0.55, color: '#E8C84C' },
    { offset: 0.70, color: '#A07818' },
    { offset: 0.82, color: '#D4A833' },
    { offset: 0.92, color: '#F0D060' },
    { offset: 1,    color: '#8B6914' }
  ];
  LsPreview.COIN_SILVER_STOPS = [
    { offset: 0,    color: '#737373' },
    { offset: 0.10, color: '#B0B0B0' },
    { offset: 0.25, color: '#E0E0E0' },
    { offset: 0.40, color: '#999999' },
    { offset: 0.55, color: '#D0D0D0' },
    { offset: 0.70, color: '#808080' },
    { offset: 0.82, color: '#B8B8B8' },
    { offset: 0.92, color: '#E0E0E0' },
    { offset: 1,    color: '#6A6A6A' }
  ];
  --- END COMMENTED OUT */
  LsPreview.COIN_GOLD_STOPS = [];
  LsPreview.COIN_SILVER_STOPS = [];

  /* ------------------------------------------------------------------
     Initialization
  ------------------------------------------------------------------ */

  function init() {
    qsa('.ls-customizer').forEach(function (el) {
      if (!el._lsCustomizer) {
        el._lsCustomizer = new LsProductCustomizer(el);
        el._lsPreview = new LsPreview(el);
      }
    });
  }

  // Init on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section events (Theme Editor)
  document.addEventListener('shopify:section:load', init);
})();